import React from 'react';
import { ChromePicker } from "react-color";
// import db, { storageConnetion } from '../../../config/firebase';
import SettingView from './SettingView';
import RouteLeavingGuard from "../../routeGuard/RouteLeavingGuard";
import { withRouter } from "react-router";
import { toast } from 'react-toastify';
import Resizer from 'react-image-file-resizer';
import { widgetImages, widgetAvatar, widgetImage } from "../../organization/badgeIconConfig";
import { activityLog } from "../../../services/service";
import { AMPLITUDE_KEY } from '../../../config/siteConfig';

import TextField from '@material-ui/core/TextField';
/* For Dropdown Start */
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import firebaseServices from '../../../firebase';
const widgetLocalization = require('../../../localization/widget.json');
/* For Dropdown End */

class Basicsettings extends React.Component {
	constructor() {
		super();
		this.agent = localStorage.getItem('agent') ? JSON.parse(localStorage.getItem('agent')) : {}
		this.state = {
			loader: false,
			headerText: '',
			defaultChatBot: '',
			ownerId: '',
			owner_email: '',
			company_name: '',
			isActiveColorPicker: false,
			rgbColor: { r: 10, g: 10, b: 10, a: 1 },
			bgColor: this.RGBAToHexA({ r: 10, g: 10, b: 10, a: 1 }),
			display: 'desktop',
			brand_uploading: false,
			avatar_uploading: false,
			badge_uploading: false,
			background_uploading: false,
			ownerName: '',
			currentTheme: { r: 10, g: 10, b: 10, a: 1 },
			headerbgColor: this.RGBAToHexA({ r: 10, g: 10, b: 10, a: 1 }),
			headerTextColor: this.RGBAToHexA({ r: 255, g: 255, b: 255, a: 1 }),
			chatbgColor: this.RGBAToHexA({ r: 10, g: 10, b: 10, a: 1 }),
			chatbgfromColor: this.RGBAToHexA({ r: 255, g: 255, b: 255, a: 1 }),
			chatbgtoColor: this.RGBAToHexA({ r: 10, g: 10, b: 10, a: 1 }),
			brandLogo: '',
			agentbgColor: this.RGBAToHexA({ r: 221, g: 230, b: 239, a: 1 }),
			agentTextColor: this.RGBAToHexA({ r: 10, g: 10, b: 10, a: 1 }),
			userbgColor: this.RGBAToHexA({ r: 44, g: 48, b: 73, a: 1 }),
			usertextColor: this.RGBAToHexA({ r: 10, g: 10, b: 10, a: 1 }),
			sendButtonColor: this.RGBAToHexA({ r: 10, g: 10, b: 10, a: 1 }),
			widgetposition: 'right',
			side_spacing: '8',
			bottom_spacing: '8',
			widgetbgColor: this.RGBAToHexA({ r: 10, g: 10, b: 10, a: 1 }),
			widgetImage: {

			},
			AvtarImg: {

			},
			avatarActive: false,
			popUpBackgroundColor: this.RGBAToHexA({ r: 44, g: 48, b: 73, a: 1 }),
			popUpMenuOpened: '1',
			popUpMessage: '',
			popUpImageSrc: 'https://firebasestorage.googleapis.com/v0/b/livechat-production.appspot.com/o/brandlogo%2Fbrand_logo.png?alt=media&token=7f5ec5b3-426f-43c9-957c-a8a9a7c9a389',
			popUpWidgetSwitch: true,
			placeholdImageSrc: 'https://firebasestorage.googleapis.com/v0/b/livechat-production.appspot.com/o/brandlogo%2Fbrand_logo.png?alt=media&token=7f5ec5b3-426f-43c9-957c-a8a9a7c9a389',
			showPopUpImagePreview: false,
			activatePopUpWidget: false,

			widgetImages: widgetImages,
			widgetAvatar: widgetAvatar,

			position: 'Right',
			brand_logos: ['https://firebasestorage.googleapis.com/v0/b/livechat-production.appspot.com/o/brandlogo%2Fbrand_logo.png?alt=media&token=7f5ec5b3-426f-43c9-957c-a8a9a7c9a389'],
			brand_logo: '',
			color: [
				{ r: 10, g: 10, b: 10, a: 1 },
				{ r: 230, g: 53, b: 33, a: 1 },
				{ r: 255, g: 206, b: 0, a: 1 },
				{ r: 140, g: 127, b: 190, a: 1 },
				{ r: 13, g: 132, b: 246, a: 1 },
				{ r: 74, g: 183, b: 115, a: 1 },
			],
			showGradient: false,
			showbasicSettings: true,
			value_saved: true,
			headertext_error: '',
			side_spacing_error: '',
			bottom_spacing_error: '',
			isColorFromPicker: false,
			showAdvancedSettings: true,
			white_label_widget: false,
			languages: [],
			defaultLanguage: 'en',
			popUpMessageError: '',
			popUpWidgetPlaceholder: 'Type your message here',
			defaultMessagePlaceholder: 'Default Message',
			typingAreaTextPlaceholder: 'Type a message',
			showWidgetStatus: 1,
			enableDisableWidgetStatus: true,
			appId: '',
		}
		// console.log("dheeraj", widgetAvatar)
	}


	RGBAToHexA(color) {
		var r = color.r.toString(16);
		var g = color.g.toString(16);
		var b = color.b.toString(16);
		var a = Math.round(color.a * 255).toString(16);

		if (r.length === 1) r = "0" + r;
		if (g.length === 1) g = "0" + g;
		if (b.length === 1) b = "0" + b;
		if (a.length === 1) a = "0" + a;

		return "#" + r + g + b + a;
	}

	hexToRgb(h) {
		let r = 0, g = 0, b = 0, a = 1;

		if (h.length === 5) {
			r = "0x" + h[1] + h[1];
			g = "0x" + h[2] + h[2];
			b = "0x" + h[3] + h[3];
			a = "0x" + h[4] + h[4];

		} else if (h.length === 9) {
			r = "0x" + h[1] + h[2];
			g = "0x" + h[3] + h[4];
			b = "0x" + h[5] + h[6];
			a = "0x" + h[7] + h[8];
		}
		a = +(a / 255).toFixed(3);

		return { r: +r, g: +g, b: +b, a: a };

	}

	changebrandImage = (item) => {
		this.setState({
			brand_logo: item,
			value_saved: false
		})
	}

	hideColorPicker = (e) => {
		let ePath = e.path || (e.composedPath && e.composedPath());
		let chromePicker = false
		if (ePath) {
			ePath.forEach((path) => {
				if (path.className && path.className === 'chrome-picker ') {
					chromePicker = true;
				}
			})
		}
		let spanId = e.target.id;
		if (e.target.className === "color-picker") {
			this.setState({ [spanId]: !this.state[spanId] })
			return true;
		} else if (chromePicker === true) {
			return true;
		} else if (this.state.isActiveColorPicker) {
			this.setState({ isActiveColorPicker: false }, () => {
				return true;
			})
			return true;
		} else if (this.state.isActivehbColorPicker) {
			this.setState({ isActivehbColorPicker: false }, () => {
				return true;
			})
			return true;
		} else if (this.state.isActiveheadertextPicker) {
			this.setState({ isActiveheadertextPicker: false }, () => {
				return true;
			})
			return true;
		} else if (this.state.isActivechatbgPicker) {
			this.setState({ isActivechatbgPicker: false }, () => {
				return true;
			})
			return true;
		} else if (this.state.isActivechatbgfromPicker) {
			this.setState({ isActivechatbgfromPicker: false }, () => {
				return true;
			})
			return true;
		} else if (this.state.isActivechatbgToPicker) {
			this.setState({ isActivechatbgToPicker: false }, () => {
				return true;
			})
			return true;
		} else if (this.state.isActiveagenttextPicker) {
			this.setState({ isActiveagenttextPicker: false }, () => {
				return true;
			})
			return true;
		} else if (this.state.isActiveuserbgPicker) {
			this.setState({ isActiveuserbgPicker: false }, () => {
				return true;
			})
			return true;
		} else if (this.state.isActiveusertextPicker) {
			this.setState({ isActiveusertextPicker: false }, () => {
				return true;
			})
			return true;
		} else if (this.state.isActivesendbtnPicker) {
			this.setState({ isActivesendbtnPicker: false }, () => {
				return true;
			})
			return true;
		} else if (this.state.isActivewidgetbgPicker) {
			this.setState({ isActivewidgetbgPicker: false }, () => {
				return true;
			})
			return true;
		} else if (this.state.isActiveagentbgPicker) {
			this.setState({ isActiveagentbgPicker: false }, () => {
				return true;
			})
			return true;
		} else {
			return true;
		}
	}

	// Commented by dharmesh for issue 1316 start here 
	// checkSubscriptionList = () => {
	//     if(this.agent.ownerId) {
	//         getOwnerSnapShot(this.agent.ownerId, async (results) => {
	//             console.log('---results>>>>> ', results);
	//             if(results.status===200) {
	//                 let _data = results.data;
	//                 this.setState({
	//                     showAdvancedSettings : _data.paymentStatus
	//                 })
	//             } else {
	//                 this.setState({
	//                     showAdvancedSettings:false
	//                 })
	//             }
	//         })
	//     }
	// }
	// Commented by dharmesh for issue 1316 ends here 

	componentDidMount() {
		var body = document.getElementById('main-div');
		body.addEventListener("click", this.hideColorPicker, false);
		this.setState({
			loader: true
		})
		let userDetails = JSON.parse(localStorage.getItem('agent'));
		this.setState({
			ownerId: userDetails.ownerId,
			owner_email: userDetails.ownerEmail,
			languages: userDetails.languages ? userDetails.languages : [],
			typingAreaTextPlaceholder: widgetLocalization[this.state.defaultLanguage].typingAreaText ? widgetLocalization[this.state.defaultLanguage].typingAreaText : 'Type a message',
			defaultMessagePlaceholder: widgetLocalization[this.state.defaultLanguage].defaultMessagePlaceholder ? widgetLocalization[this.state.defaultLanguage].defaultMessagePlaceholder : 'Default Message',
		})
		//fetch details from this api https://72snappy.appypie.com/webservices/integration.php' for showWidgetStatus
		let checkAppId = firebaseServices.db.collection('users').doc(userDetails.ownerId).get().then((doc) => {
			if (doc.exists) {
				if (doc.data().appId && doc.data().integrated) {
					let data = fetch('https://72snappy.appypie.com/webservices/integration.php', {
						method: 'POST',
						headers: {
							'Content-Type': 'application/json'
						},
						body: JSON.stringify({ "method": "getLiveChatStatus", "appId": doc.data().appId })
					}).then(response => response.json()).then(data => {
						this.setState({
							showWidgetStatus: data.status,
							appId: doc.data().appId
						})
					}).catch(error => {
						console.log('error', error);
					});
				}
			}
		});

		// this.checkSubscriptionList();
		var defChat = firebaseServices.db.collection('users').doc(userDetails.ownerId).collection('chatbots').where("status", '==', 1).onSnapshot(async (docs) => {
			if (!docs.empty) {
				let defaultChatBot = ''
				docs.forEach((doc) => {
					defaultChatBot = doc.id
				})
				this.setState({
					defaultChatBot: defaultChatBot
				})
				defChat();
				var temDetails3 = firebaseServices.db.collection('users').doc(userDetails.ownerId).collection('chatbots').doc(defaultChatBot);
				await temDetails3.get().then((doc) => {
					if (doc.exists) {
						this.setState({ activatePopUpWidget: doc.data().activatePopUpWidget ? doc.data().activatePopUpWidget : false });
					} else {
						this.setState({ activatePopUpWidget: false });
					}
				}).catch((error) => {
					console.log("Error getting document:", error);
				});
				var temDetails = firebaseServices.db.collection('users').doc(userDetails.ownerId).collection('chatbots').doc(defaultChatBot).collection('editedBots').doc('template').onSnapshot((templateData) => {
					if (templateData.exists) {
						temDetails();
						let customiseData = templateData.data().customisation;
						let widgetImageExist = false;

						console.log("this.widget.images", this.state.widgetImages)
						this.state.widgetImages.forEach((images, key) => {
							if (images.fbwtimage === customiseData.widgetImage) {
								widgetImageExist = true;
								this.setState({
									widgetImage: images,
								})
							}
						})
						let widgetAvatarExist = false;
						console.log("this.widget.avatar", this.state.widgetAvatar)
						this.state.widgetAvatar.forEach((images, key) => {
							console.log("avatar images", images, customiseData.widgetAvatar)
							if (images.fbwtimage === customiseData.widgetAvatar) {
								widgetAvatarExist = true;
								this.setState({
									AvtarImg: images,
								})
							}
							if (customiseData.isAvatarImage === true) {
								this.setState({
									avatarActive: true
								})
							}
						})
						console.log("widgetImageExist---312", widgetImageExist, widgetAvatarExist)
						if (!widgetImageExist) {
							let nImage = {
								wtimage: customiseData.widgetImage,
								fbwtimage: customiseData.widgetImage,
								blackImage: customiseData.widgetImage
							}

							let allWidgets = this.state.widgetImages;

							allWidgets.push(nImage);
							this.setState({
								widgetImages: allWidgets,
								widgetImage: nImage
							})

						}
						if (widgetAvatarExist) {
							let nImageAva = {
								wtimage: customiseData?.widgetAvatar,
								fbwtimage: customiseData?.widgetAvatar,
								blackImage: customiseData?.widgetAvatar
							}
							let allAvatar = this.state.widgetAvatar
							allAvatar.push(nImageAva)
							this.setState({
								AvtarImg: nImageAva,
								widgetAvatar: allAvatar
							})
							if (customiseData.isAvatarImage === true) {
								this.setState({
									avatarActive: true
								})
								document.getElementById('widAvatar').classList.add('avtarView')
								console.log("avatarActive---34", this.state.avatarActive)
							}
						}else{
							this.setState({
								AvtarImg: this.state.widgetAvatar[0],
								
							})
						}

						console.log("widgetAvatar-----341", this.state.widgetAvatar, this.state.widgetImages)
						if (customiseData.showGradient) {
							this.setState({
								showGradient: true,
								chatbgfromColor: customiseData.backgroundFromChatBot,
								chatbgtoColor: customiseData.backgroundChatToBot
							})
						}
						this.setState({
							chatbgColor: customiseData.backgroundChatBot,
							agentTextColor: customiseData.botButtonTextColor,
							agentbgColor: customiseData.messagebubble,
							brand_logo: customiseData.chatBotAvtar,
							usertextColor: customiseData.clientchattextcolor,
							headerbgColor: customiseData.headerClr,
							headerText: customiseData.headerName,
							headerTextColor: customiseData.headertextcolor,
							sendButtonColor: customiseData.sendButtonClr,
							widgetbgColor: customiseData.widgetBackgroundColor,
							bottom_spacing: customiseData.widgetPosition.bottom,
							widgetposition: customiseData.widgetPosition.position,
							side_spacing: customiseData.widgetPosition.side,
							loader: false,
							userbgColor: customiseData.clientBubbleClr,
							bgColor: customiseData.headerClr,
							headerText: customiseData.headerName,
							position: customiseData.widgetPosition.position,
							brand_logo: customiseData.chatBotAvtar,
							loader: false,
							white_label_widget: customiseData.white_label_widget ? customiseData.white_label_widget : false
						})
						// this.setState({
						//     bgColor:customiseData.headerClr,
						//     headerText:customiseData.headerName,
						//     position:customiseData.widgetPosition.position,
						//     brand_logo:customiseData.chatBotAvtar,
						//     loader:false
						// })

						let colCustom = false;
						this.state.color.forEach((col) => {
							let hexCol = this.RGBAToHexA(col);
							if (hexCol === customiseData.headerClr) {
								colCustom = true;
							}
						})
						if (!colCustom) {
							this.setState({
								isColorFromPicker: true
							})
						}

						if (this.state.brand_logos.indexOf(customiseData.chatBotAvtar) === -1) {
							let brandsList = this.state.brand_logos;
							brandsList.push(customiseData.chatBotAvtar);
							this.setState({
								brand_logos: brandsList
							})
						}
					}
				});
				////////////////
				let templateId = this.state.defaultLanguage === 'en' ? 'template' : 'template_' + this.state.defaultLanguage;
				var temDetails2 = firebaseServices.db.collection('users').doc(userDetails.ownerId).collection('chatbots').doc(defaultChatBot).collection('editedBots').doc(templateId).onSnapshot((templateData) => {
					if (templateData.exists) {
						temDetails2();
						let popUpSettings = templateData.data().popUpSettings;
						if (popUpSettings) {
							this.setState({
								popUpBackgroundColor: popUpSettings.popUpBackgroundColor,
								popUpMenuOpened: popUpSettings.popUpMenuOpened,
								popUpMessage: popUpSettings.popUpMessage,
								popUpImageSrc: popUpSettings.popUpImageSrc,
								showPopUpImagePreview: popUpSettings.showPopUpImagePreview,
								popUpWidgetPlaceholder: popUpSettings.popUpWidgetPlaceholder ? popUpSettings.popUpWidgetPlaceholder : widgetLocalization[this.state.defaultLanguage].popUpWidgetPlaceholder,
								loader: false,
							},
								() => {
									if (this.state.popUpMenuOpened !== '' && this.state.popUpMenuOpened !== undefined && this.state.activatePopUpWidget) {
										this.openPopUpMenu(this.state.popUpMenuOpened);
									}
								}
							)
						}
					}
				});
				///////////////
			}
		})

		activityLog("Opened widget settings page");
	}

	makeid = (length) => {
		let result = '';
		let characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
		let charactersLength = characters.length;
		for (var i = 0; i < length; i++) {
			result += characters.charAt(Math.floor(Math.random() * charactersLength));
		}
		return result;
	}

	uploadbadgeImage = async (e) => {
		this.setState({ value_saved: false })
		console.log("e.target.files", e.target.id, this.state.widgetImage)
		let files = e.target.files;
		document.getElementById('widAvatar').classList.remove('avtarView')
		if (e.target.id === "add_badge_avatar") {
			this.setState({
				avatar_uploading: true,
			})
			document.getElementById('widAvatar').classList.add('avtarView')
			this.imageUploads(files[0], 'badge_avatar');
			await this.setState({ avatarActive: true })
			console.log("avatarActive---455", this.state.avatarActive, this.state.widgetImage)
		} else {
			this.setState({
				badge_uploading: true,
			})
			this.imageUploads(files[0], 'badge');
			this.setState({ avatarActive: false })
			console.log("avatarActive---463", this.state.avatarActive, this.state.widgetImage)
		}

	}

	uploadBrandLogo = (e) => {
		this.setState({
			brand_uploading: true,
			value_saved: false
		})
		let files = e.target.files;
		this.imageUploads(files[0], 'brand');
	}

	uploadBackgroundImage = (event, width, height) => {
		this.setState({
			background_uploading: true,
			value_saved: false
		})
		let files = event.target.files;
		this.imageUploads(files[0], 'background', width = width, height = height);
	}

	async imageUploads(file, type, width = 64, height = 64) {
		const ref = firebaseServices.storageConnection;

		console.log("ref", ref, firebaseServices.storageConnection)
		let fileExt = (/[.]/.exec(file.name)) ? /[^.]+$/.exec(file.name) : 'png';
		const name = +new Date() + "-" + this.makeid(7) + '.' + fileExt;
		const metadata = {
			contentType: file.type
		};
		//var _this = this
		var task;
		let promise1 = new Promise(async (res, rej) => {
			Resizer.imageFileResizer(
				file,
				width,
				height,
				'PNG',
				100,
				0,
				async uri => {
					if (type === 'brand') {
						task = ref.child('brandlogo').child('avatar').child(name).put(uri, metadata);
					}
					else if (type === 'background') {
						task = ref.child(this.agent.organization_alias).child('backgroundImageAvatar').child('backgroundImageResized_' + this.state.defaultLanguage).put(uri, metadata);
					} else if (type === 'badge_avatar') {
						console.log("badge_avatar", ref)
						task = ref.child('badgeicon').child('badge_avatar').child(name).put(uri, metadata);
					}
					else {
						task = ref.child('badgeicon').child('avatar').child(name).put(uri, metadata);
					}
					await task
						.then(snapshot => snapshot.ref.getDownloadURL())
						.then(url => {
							res(url);
						})
						.catch((err) => {
							rej(err);
						});
				}, 'blob'
			);
		})
		let promise2 = new Promise(async (resolve, reject) => {
			if (type === 'brand') {
				task = ref.child('brandlogo').child(name).put(file, metadata);
			}
			else if (type === 'background') {
				task = ref.child(this.agent.organization_alias).child('backgroundImageOriginal_' + this.state.defaultLanguage).put(file, metadata);
			} else if (type === 'badge_avatar') {
				task = ref.child('badgeicon').child('badge_avatar').child(name).put(file, metadata);
			}
			else {
				task = ref.child('badgeicon').child(name).put(file, metadata);
			}
			await task
				.then(snapshot => snapshot.ref.getDownloadURL())
				.then(url => {
					resolve(url);
				})
				.catch((err) => {
					reject(err);
				});
		})

		Promise.all([promise1, promise2]).then((result) => {
			this.updatebadgeFiles(result[0], name, type);
		}).catch((err) => {
			console.log(err);
		})
	}

	updatebadgeFiles = (url, name, type) => {
		console.log("url", url, name, type)
		if (type === 'brand') {
			let brandsList = this.state.brand_logos;
			brandsList.push(url);
			this.setState({
				brand_logos: brandsList,
				brand_logo: url,
				brand_uploading: false
			})
		} else if (type === 'background') {
			this.setState({
				popUpImageSrc: url,
				background_uploading: false
			});
		} else if (type === 'badge_avatar') {

			let avatar = {
				wtimage: name,
				fbwtimage: url,
				blackImage: url,
			}
			let allAvatar = this.state.widgetAvatar
			allAvatar.push(avatar)
			this.setState({
				widgetAvatar: allAvatar,
				AvtarImg: avatar,
				avatar_uploading: false,
				avatarActive: true
			})
		}
		else {
			let newImage = {
				wtimage: name,
				fbwtimage: url,
				blackImage: url,

			}
			let allWidgets = this.state.widgetImages;
			allWidgets.push(newImage);

			this.setState({
				widgetImages: allWidgets,
				widgetImage: newImage,
				badge_uploading: false,
				avatarActive: false
				// allAvatar: newImage,
			})
			console.log("1234567890", this.state.allAvatar)
		}
	}

	chooseBackGroundColor = (item) => {
		const bgColor = this.RGBAToHexA(item);
		this.setState({
			userbgColor: bgColor,
			headerbgColor: bgColor,
			sendButtonColor: bgColor,
			widgetbgColor: bgColor,
			'rgbColor': item,
			bgColor: bgColor,
			value_saved: false,
			isActiveColorPicker: false,
			isColorFromPicker: false
		})

		if (this.state.activatePopUpWidget) {
			if (document.getElementById("sameBackgroundColor1").checked ||
				document.getElementById("sameBackgroundColor2").checked ||
				document.getElementById("sameBackgroundColor3").checked ||
				document.getElementById("sameBackgroundColor4").checked) {
				this.setState({ popUpBackgroundColor: bgColor })
			}
		}

	}

	changeChatImage = async (item, type) => {

		document.getElementById('widAvatar').classList.remove('avtarView')
		if (type === 'Avatar') {
			document.getElementById('widAvatar').classList.add('avtarView')
			console.log(document.getElementById('widAvatar'))
			await this.setState({ AvtarImg: item, avatarActive: true })
			console.log("-----chatchatimage12----", this.state.avatarActive)
			// this.setState({avatarActive:'avtarView'})
		} else {
			this.setState({ widgetImage: item, value_saved: false });
			await this.setState({ avatarActive: false })
			console.log("-----chatchatimage----", this.state.avatarActive)
		}


	}

	onChangeBasicColorPicker = (background, color) => {
		const bgColor = this.RGBAToHexA(color.rgb);
		this.setState({
			userbgColor: bgColor,
			headerbgColor: bgColor,
			sendButtonColor: bgColor,
			widgetbgColor: bgColor,
			'rgbColor': color,
			bgColor: bgColor,
			value_saved: false,
			isColorFromPicker: true
		})
	}

	onChangeColorPicker = (backgrouns, color) => {
		const bgColor = this.RGBAToHexA(color.rgb);
		if (backgrouns === 'headerbgColor') {
			this.setState({
				'rgbColor': color,
				bgColor: bgColor,
			})
		}
		this.setState({ [backgrouns]: bgColor, value_saved: false })
	}

	headerChange = (e) => {
		let target = e.target;
		this.setState({
			headerText: target.value,
			value_saved: false
		})
		if (target.value === '') {
			this.setState({
				headertext_error: 'This field can not be blank!'
			})
		} else {
			this.setState({
				headertext_error: ''
			})
		}
	}

	changeDisplay = (display) => {
		this.setState({
			display: display,
			value_saved: false
		})
	}

	updatePoition = (e) => {
		let target = e.target;
		this.setState({
			[target.name]: target.value,
			value_saved: false
		})
	}

	componentDidUpdate() {
		if (this.props.cancelForm) {
			this.props.updateValues();
			this.cancelForm();
		}

		if (this.props.submitForm) {
			this.props.updateValues();
			this.saveForm();
		}
	}

	cancelForm = () => {
		this.componentDidMount();
		this.hideActiveColorPickers();
		this.setState({
			value_saved: true
		})
	}

	// saveForm = (e) => {
	//     let values = {
	//         backgroundChatBot:'#FFFFFF',
	//         botButtonColor:'#2c3049ff',
	//         botButtonText:'lora',
	//         botButtonTextColor:'#FFFFFF',
	//         botTextcolor:'#000000',
	//         chatBotAvtar:this.state.brand_logo,
	//         clientBubbleClr:this.state.bgColor,
	//         clientchattextcolor:'#FFFFFF',
	//         designLanguage:'english(en)',
	//         designPage:'default',
	//         headerClr:this.state.bgColor,
	//         headerName:this.state.headerText,
	//         headertextcolor:'#FFFFFF',
	//         messagebubble:"#2c30494d",
	//         sendButtonClr:this.state.bgColor,
	//         textfonts:'roboto',
	//         widgetBackgroundColor:this.state.bgColor,
	//         widgetPosition : {
	//             bottom:'8',
	//             position:this.state.position,
	//             side:'8'
	//         },
	//         widgetSize:'large',

	//         widgetImage:this.state.widgetImage,
	//         showGradient:this.state.showGradient,
	//         backgroundFromChatBot:this.state.chatbgfromColor,
	//         backgroundChatToBot:this.state.chatbgtoColor
	//     }
	//     this.setState({
	//         loader:true
	//     })
	//     firebaseServices.db.collection('users').doc(this.state.ownerId).collection('chatbots').doc(this.state.defaultChatBot).collection('editedBots').doc('template').update({
	//         customisation:values
	//     }).then((docs) => {
	//         this.setState({
	//             loader:false
	//         })
	//     })
	// }

	validateForm = (e) => {
		let returnValue = true;
		if (this.state.headerText === '') {
			returnValue = false;
			this.setState({
				headertext_error: 'This field can not be blank!'
			})
		}
		if (this.state.bottom_spacing === '') {
			returnValue = false;
			this.setState({
				bottom_spacing_error: 'This field can not be blank!'
			})
		} else if (this.state.bottom_spacing < 0) {
			returnValue = false
			this.setState({
				bottom_spacing_error: 'value must be greater than 0'
			})
		}

		if (this.state.side_spacing === '') {
			returnValue = false;
			this.setState({
				side_spacing_error: 'This field can not be blank!'
			})
		} else if (this.state.side_spacing < 0) {
			returnValue = false
			this.setState({
				side_spacing_error: 'value must be greater than 0'
			})
		}

		if (this.state.popUpMessage === '' && this.state.popUpMenuOpened !== '3' && this.state.activatePopUpWidget) {
			returnValue = false
			this.setState({
				popUpMessageError: 'This field can not be blank!'
			})
		}

		return returnValue;
	}

	saveForm = () => {
		let validate = this.validateForm();
		if (!validate) {
			return;
		}
		this.hideActiveColorPickers();
		let values = {
			backgroundChatBot: this.state.chatbgColor,
			botButtonColor: '#000',
			botButtonText: 'lora',
			botButtonTextColor: this.state.agentTextColor,
			botTextcolor: this.state.agentTextColor,
			chatBotAvtar: this.state.brand_logo,
			clientBubbleClr: this.state.userbgColor,
			clientchattextcolor: this.state.usertextColor,
			designLanguage: 'english(en)',
			designPage: 'advance',
			headerClr: this.state.headerbgColor,
			headerName: this.state.headerText,
			headertextcolor: this.state.headerTextColor,
			messagebubble: this.state.agentbgColor,
			sendButtonClr: this.state.sendButtonColor,
			textfonts: 'roboto',
			widgetBackgroundColor: this.state.widgetbgColor,
			widgetPosition: {
				bottom: this.state.bottom_spacing,
				position: this.state.widgetposition,
				side: this.state.side_spacing
			},
			widgetSize: 'large',
			widgetImage: this.state.widgetImage.fbwtimage,
			isAvatarImage: this.state.avatarActive,
			widgetAvatar: this.state.AvtarImg.fbwtimage,
			showGradient: this.state.showGradient,
			backgroundFromChatBot: this.state.chatbgfromColor,
			backgroundChatToBot: this.state.chatbgtoColor,
			white_label_widget: this.state.white_label_widget
		}
		console.log("------values------", values)
		this.setState({
			loader: true
		})
		firebaseServices.db.collection('users').doc(this.state.ownerId).collection('chatbots').doc(this.state.defaultChatBot).collection('editedBots').doc('template').update({
			customisation: values
		}).then((docs) => {
			let popUpSettings = {
				popUpBackgroundColor: this.state.popUpBackgroundColor,
				popUpMenuOpened: this.state.popUpMenuOpened,
				popUpMessage: this.state.popUpMessage,
				popUpImageSrc: this.state.popUpImageSrc,
				// activatePopUpWidget: this.state.activatePopUpWidget,
				showPopUpImagePreview: this.state.showPopUpImagePreview,
				popUpWidgetPlaceholder: widgetLocalization[this.state.defaultLanguage].popUpWidgetPlaceholder ? widgetLocalization[this.state.defaultLanguage].popUpWidgetPlaceholder : "Type your message here",
			};
			firebaseServices.db.collection('users').doc(this.state.ownerId).collection('chatbots').doc(this.state.defaultChatBot).update({
				activatePopUpWidget: this.state.activatePopUpWidget
			})
			let templateId = this.state.defaultLanguage === 'en' ? 'template' : 'template_' + this.state.defaultLanguage;
			firebaseServices.db.collection('users').doc(this.state.ownerId).collection('chatbots').doc(this.state.defaultChatBot).collection('editedBots').doc(templateId).get().then((d) => {
				if (d.exists) {
					firebaseServices.db.collection('users').doc(this.state.ownerId).collection('chatbots').doc(this.state.defaultChatBot).collection('editedBots').doc(templateId).update({ popUpSettings: popUpSettings });
				}
				else {
					firebaseServices.db.collection('users').doc(this.state.ownerId).collection('chatbots').doc(this.state.defaultChatBot).collection('editedBots').doc(templateId).set({ popUpSettings: popUpSettings });
				}
			})
		}).then((docs) => {

			toast.success('Widget settings has been updated successfully!');
			this.setState({
				loader: false,
				value_saved: true
			})

		})

	}

	changeToGradient = (value) => {
		this.setState({
			showGradient: value,
			value_saved: false
		})
	}

	changePositions = (e) => {
		let target = e.target;
		this.setState({
			[target.name]: target.value,
			value_saved: false
		})
		let error_name = target.name + '_error';
		if (target.value === '') {
			this.setState({
				[error_name]: 'This field can not be blank!'
			})
		} else if (target.value < 0) {
			this.setState({
				[error_name]: 'Value must be greater than 0'
			})
		} else {
			this.setState({
				[error_name]: ''
			})
		}
	}

	changeSettings = (flag) => {
		this.setState({
			showbasicSettings: flag
		},
			() => {
				if (this.state.popUpMenuOpened !== '' && this.state.popUpMenuOpened !== undefined && this.state.activatePopUpWidget) {
					if (flag) {
						this.openPopUpMenu(this.state.popUpMenuOpened);
					}
					// else { // pop up widget in advance settings
					//     this.openPopUpMenu(this.state.popUpMenuOpened, "Advance");
					// }
				}
			}
		)
	}

	hideActiveColorPickers = () => {
		this.setState({
			isActivehbColorPicker: false,
			isActiveheadertextPicker: false,
			isActivewidgetbgPicker: false,
			isActivechatbgPicker: false,
			isActivechatbgfromPicker: false,
			isActivechatbgToPicker: false,
			isActiveagentbgPicker: false,
			isActiveagenttextPicker: false,
			isActiveuserbgPicker: false,
			isActiveusertextPicker: false,
			isActivesendbtnPicker: false,
			isActiveColorPicker: false
		})
	}

	showColorPicker = (v) => {
		let curValue = this.state[v];
		this.hideActiveColorPickers();
		this.setState({
			[v]: !curValue
		})
	}


	rightWidgetMobileHide = () => {
		document.getElementById('deskWidgetRightP').classList.toggle('d-none');
		document.getElementById('widgeHSIcon').classList.toggle('rotteIcon');
	}

	openPopUpMenu = (popUpMenuOpenedNumber, advance = "") => {
		// console.log("\n\n\n💡🛠 -> file: basicSettings.js -> line 784 -> popUpMenuOpenedNumber", popUpMenuOpenedNumber);
		const popUpDict = { "1": "imageRight", "2": "imageLeft", "3": "textOnly", "4": "imageOnly" };
		let popUp = popUpDict[popUpMenuOpenedNumber] + advance;
		console.log("\n\n\n💡🛠 -> file: basicSettings.js -> line 845 -> popUp", popUp);
		try {
			if (this.state.activatePopUpWidget === true) {
				var i, tabcontent, tablinks;
				tabcontent = document.getElementsByClassName("tabcontent");
				for (i = 0; i < tabcontent.length; i++) {
					tabcontent[i].style.display = "none";
				}
				// tablinks = document.getElementsByClassName("tablinks");
				// for (i = 0; i < tablinks.length; i++) {
				//     tablinks[i].className = tablinks[i].className.replace(" active", "");
				// }
				document.getElementById(popUp).style.display = "block";

				this.setState({
					popUpMenuOpened: popUpMenuOpenedNumber,
				});
			}
		}
		catch (err) { console.log("Some error in popUpMenu: ", JSON.stringify(err)) }
		// event.currentTarget.className += " active";
	}

	handleOnClick = (event) => {
		let colorPicker1 = document.getElementById("backgroundColorPopUp1");
		let colorPicker2 = document.getElementById("backgroundColorPopUp2");
		let colorPicker3 = document.getElementById("backgroundColorPopUp3");
		let colorPicker4 = document.getElementById("backgroundColorPopUp4");

		if (event.target.checked) {
			this.setState({ popUpBackgroundColor: this.state.userbgColor });
			colorPicker1.disabled = true;
			colorPicker1.value = this.state.userbgColor;
			colorPicker2.disabled = true;
			colorPicker2.value = this.state.userbgColor;
			colorPicker3.disabled = true;
			colorPicker3.value = this.state.userbgColor;
			colorPicker4.disabled = true;
			colorPicker4.value = this.state.userbgColor;
			document.getElementById("sameBackgroundColor1").checked = event.target.checked;
			document.getElementById("sameBackgroundColor2").checked = event.target.checked;
			document.getElementById("sameBackgroundColor3").checked = event.target.checked;
			document.getElementById("sameBackgroundColor4").checked = event.target.checked;
		}
		else {
			colorPicker1.disabled = false;
			colorPicker2.disabled = false;
			colorPicker3.disabled = false;
			colorPicker4.disabled = false;
			document.getElementById("sameBackgroundColor1").checked = event.target.checked;
			document.getElementById("sameBackgroundColor2").checked = event.target.checked;
			document.getElementById("sameBackgroundColor3").checked = event.target.checked;
			document.getElementById("sameBackgroundColor4").checked = event.target.checked;
		}
	}
	showPopUpImage = (event, previewId, id, src, width, height) => {
		try {
			event.persist();
			const [file] = event.target.files;
			if (file.type !== 'image/png' && file.type !== 'image/jpeg' && file.type !== 'image/jpg' && file.type !== 'image/bmp') {
				toast.error(`${file.name} is not an image file`);
				try {
					document.getElementById(id).value = "";
					document.getElementById(previewId).src = src;
					this.setState({ showPopUpImagePreview: false, popUpImageSrc: src });
				} catch (e) { }
			}
			else if (file.size > 1048576) { // greater than 1 MB
				toast.error('Image is too Big, please select an image less than 1MB');
				try {
					document.getElementById(id).value = "";
					document.getElementById(previewId).src = src;
					this.setState({ showPopUpImagePreview: false, popUpImageSrc: src });
				} catch (e) { }
			}
			else {
				this.uploadBackgroundImage(event, width, height);
				this.setState({ showPopUpImagePreview: true }, () => {
					var popUpImagePreview = document.getElementById(previewId);
					if (file) {
						popUpImagePreview.src = URL.createObjectURL(file);
						this.setState({
							popUpImageSrc: URL.createObjectURL(file)
						});
					}
				});
			}
		}
		catch (e) { }
	}

	// multiple language for popUp widget
	handleDefaultLanguage = (e) => {
		this.setState({
			loader: true,
			defaultLanguage: e.target.value
		}, () => {
			this.getValues(this.state.ownerId, this.state.defaultChatBot)
		})
	}

	getValues = (ownerId, defaultChatBot) => {
		this.setState({
			loader: true
		})

		let templateId = this.state.defaultLanguage === 'en' ? 'template' : 'template_' + this.state.defaultLanguage;
		let promise1 = new Promise((res, rej) => {
			let popUpSettings = {
				popUpBackgroundColor: "#2c3049",
				popUpImageSrc: "https://firebasestorage.googleapis.com/v0/b/livechat-production.appspot.com/o/brandlogo%2Fbrand_logo.png?alt=media&token=7f5ec5b3-426f-43c9-957c-a8a9a7c9a389",
				popUpMenuOpened: "1",
				// activatePopUpWidget: false,
				popUpMessage: widgetLocalization[this.state.defaultLanguage].defaultMessagePlaceholder ? widgetLocalization[this.state.defaultLanguage].defaultMessagePlaceholder : "Default Message",
				showPopUpImagePreview: false,
				popUpWidgetPlaceholder: widgetLocalization[this.state.defaultLanguage].popUpWidgetPlaceholder ? widgetLocalization[this.state.defaultLanguage].popUpWidgetPlaceholder : "Type your message here",
			}
			var formDetails = firebaseServices.db.collection('users').doc(ownerId).collection('chatbots').doc(defaultChatBot).collection('editedBots').doc(templateId).onSnapshot((doc) => {
				if (doc.exists) {
					formDetails();
					if (doc.data().popUpSettings) {
						popUpSettings = doc.data().popUpSettings;
					}
				}
				res(popUpSettings);
			})
		})
		Promise.all([promise1]).then((popUpSettings) => {
			this.setState({
				popUpBackgroundColor: popUpSettings[0].popUpBackgroundColor,
				popUpMenuOpened: popUpSettings[0].popUpMenuOpened,
				popUpMessage: popUpSettings[0].popUpMessage ? popUpSettings[0].popUpMessage : widgetLocalization[this.state.defaultLanguage].defaultMessagePlaceholder,
				popUpImageSrc: popUpSettings[0].popUpImageSrc,
				// activatePopUpWidget: popUpSettings[0].activatePopUpWidget,
				showPopUpImagePreview: popUpSettings[0].showPopUpImagePreview,
				popUpWidgetPlaceholder: popUpSettings[0].popUpWidgetPlaceholder ? popUpSettings[0].popUpWidgetPlaceholder : "Type your message here",
				defaultMessagePlaceholder: widgetLocalization[this.state.defaultLanguage].defaultMessagePlaceholder ? widgetLocalization[this.state.defaultLanguage].defaultMessagePlaceholder : 'Default Message',
				typingAreaTextPlaceholder: widgetLocalization[this.state.defaultLanguage].typingAreaText ? widgetLocalization[this.state.defaultLanguage].typingAreaText : 'Type a message',
				loader: false
			}, () => {
				if (this.state.activatePopUpWidget) {
					let textArea = document.getElementById('popUpMessage1');
					textArea.value = this.state.popUpMessage;
					textArea = document.getElementById('popUpMessage2');
					textArea.value = this.state.popUpMessage;
					textArea = document.getElementById('popUpMessage3');
					textArea.value = this.state.popUpMessage;
					this.openPopUpMenu(this.state.popUpMenuOpened);
				}
			})
		})
	}


	 removeDuplicates = (arr, property) => {
		const seen = new Set();
		return arr.filter(obj => {
		  const value = obj[property];
		  if (seen.has(value)) {
			return false;
		  }
		  seen.add(value);
		  return true;
		});
	  }

	render() {
		const { history } = this.props
		let brandLogoUploading;
		if (this.state.brand_uploading) {
			brandLogoUploading = <li><span><img alt="" src={require('./../../../assets/images/processing.gif')} /></span></li>;
		}
		let avatarUploading
		if (this.state.avatar_uploading) {
			avatarUploading = <li><span><img alt="" src={require('./../../../assets/images/processing.gif')} /></span></li>;
		}
		let badgeLogoUploading;
		if (this.state.badge_uploading) {
			badgeLogoUploading = <li><span><img alt="" src={require('./../../../assets/images/processing.gif')} /></span></li>;
		}

		let backgroundImageUploading;
		if (this.state.background_uploading) {
			backgroundImageUploading = <span className='loader-overflow'><img alt="" src={require('./../../../assets/images/processing.gif')} /></span>;
		}
		return (
			<>
				<div className="loading" style={{ display: this.state.loader ? 'block' : 'none' }}>Loading&#8230;</div>
				<div className="page-wrapper sidebar-collapse right-panel-widget-show" data-mobile-height="" id="main-div">
					<div className="main-wrapper container-fluid">
						<div className="chatform-Preview">
							<div className="container-fluid">
								<div className="row">
									<div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 my-8">
										<div className="bg-white left-widgetsetings-box mb-foter-Fixed">
											{this.state.appId && <div className='k-flex align-items-center mb-3'>
												<div className="main-heading main-heading-title py-5 px-5">
													<h3 className="heding-text">Enable Widget for your App/Website</h3>
												</div>
												<div className="mx-5 custom-switch">
													<input type="checkbox" className="custom-control-input" id="switchWidget" name="popUpWidgetCheck" checked={this.state.showWidgetStatus} onChange={(event) => {
														if (event.target.checked) {
															this.setState({ showWidgetStatus: event.target.checked })
															fetch('https://72snappy.appypie.com/webservices/integration.php', {
																method: 'POST',
																headers: {
																	'Content-Type': 'application/json'
																},
																body: JSON.stringify({ "method": "enableLiveChatStatus", "appid": this.state.appId, "type": "livechat", "email": this.state.owner_email })
															}).then(response => response.json())
														} else {
															this.setState({ showWidgetStatus: event.target.checked })
															fetch('https://72snappy.appypie.com/webservices/integration.php', {
																method: 'POST',
																headers: {
																	'Content-Type': 'application/json'
																},
																body: JSON.stringify({ "method": "disableLiveChatStatus", "appid": this.state.appId })
															}).then(response => response.json())
														}
													}} />
													<label className="custom-control-label" htmlFor="switchWidget"></label>
												</div></div>}
											{this.state.showWidgetStatus ? <div className="chat-forms">
												<div className="main-heading main-heading-title py-5 px-5">
													<h3 className="heding-text">Widget Settings</h3>
												</div>
												<div className="perfect Feilds mob-px-4 accordian-view">
													<h4 className="heding-text px-4 py-4 position-relative" onClick={() => this.changeSettings(true)}>Basic Settings <span className="down-arrow active"></span></h4>
													{/* <div className="settings-form-feilds">
                                                        <div className="settings-feld form-feilds k-flex align-items-center">
                                                            <span className="main-checkbox-all"><label className="containerRadio containerafterchecked">
                                                                <input type="radio" name="set_default_settings" onChange={() => this.changeSettings(true)} checked={this.state.showbasicSettings ? true : false} defaultValue="true" />
                                                                <span className="radioCheckmark" />
                                                            </label></span>
                                                            
                                                        </div>
                                                    </div> */}
												</div>
												{this.state.showbasicSettings ? (<div className="chat-forems-section">
													<div className="row">
														<div className="col-md-12">
															<div className="chat-feilds py-5 mx-8 mob-mx-4">
																<div className="input-group material-input">
																	<div className="form-feilds k-flex align-items-center">
																		{/* <div className="settings-feld pr-4"><h6 className="card-title mb-0 mt--25">Header Name</h6></div> */}
																		<TextField className="form-control w-100" variant="outlined" value={this.state.headerText} onChange={this.headerChange} label="Header Name" />
																		{/* <input type="text" placeholder="Header Name" value={this.state.headerText} onChange={this.headerChange} /> */}
																		<p className="error">{this.state.headertext_error}</p>
																	</div>
																</div>
															</div>
														</div>
													</div>
													<div className="row">
														<div className="col-md-12 col-xs-12">
															<div className="chat-feilds py-5 mx-8 mob-mx-4 borderBottom">
																<div className="widget-brandLogo widget-sec">
																	<h5 className="card-title mb-0">Brand Logo</h5>
																	<ul className="pt-3">
																		{
																			this.state.brand_logos.map((item, i) =>
																			(

																				(<li
																					className={
																						this.state.brand_logo === item
																							? "active"
																							: ""
																					}
																					onClick={() => this.changebrandImage(item)} key={i}>

																					<span><img src={item} alt="" /></span>


																				</li>)


																			)
																			)
																		}

																		{brandLogoUploading}
																		<li className="lastes"><span className="agent-rightpanel-feilds position-relative">
																			<input type="file" className="w-100" id="add_brand_logo" accept="image/*" name="add_brand_logo" onChange={this.uploadBrandLogo} />
																			<span className="k-flex align-items-center mt-1">
																				<svg xmlns="http://www.w3.org/2000/svg" width="18.202" height="18.199" viewBox="0 0 18.202 18.199">
																					<path id="Icon_awesome-upload" data-name="Icon awesome-upload" d="M10.523,13.654H7.679a.851.851,0,0,1-.853-.853V6.828H3.708a.71.71,0,0,1-.5-1.212L8.614.205a.689.689,0,0,1,.971,0L15,5.616a.71.71,0,0,1-.5,1.212H11.376V12.8A.851.851,0,0,1,10.523,13.654ZM18.2,13.37v3.982a.851.851,0,0,1-.853.853H.853A.851.851,0,0,1,0,17.352V13.37a.851.851,0,0,1,.853-.853H5.688V12.8a1.992,1.992,0,0,0,1.991,1.991h2.844A1.992,1.992,0,0,0,12.514,12.8v-.284h4.835A.851.851,0,0,1,18.2,13.37ZM13.794,16.5a.711.711,0,1,0-.711.711A.713.713,0,0,0,13.794,16.5Zm2.275,0a.711.711,0,1,0-.711.711A.713.713,0,0,0,16.069,16.5Z" transform="translate(0 -0.005)" fill="#fff" />
																				</svg>
																			</span>
																		</span></li>
																	</ul>
																</div>
															</div>
														</div>
													</div>

													<div className="row">
														<div className="col-md-12 ">
															<div className="chat-feilds py-5 mx-8 mob-mx-4 borderBottom">
																<div className="widget-theme widget-sec">
																	<h6 className="card-title mb-0">Theme color</h6>
																	<ul className="pt-3">


																		{
																			this.state.color.map((item, i) => {

																				return (<li
																					className={
																						this.state.bgColor === this.RGBAToHexA(item) && !this.state.isColorFromPicker ? 'active' : ''
																					}
																					onClick={() => this.chooseBackGroundColor(item)}
																					key={i}>
																					<span style={{ backgroundColor: this.RGBAToHexA(item) }}> </span>

																				</li>)

																			})
																		}

																		{
																			this.state.isColorFromPicker &&
																			(<li onClick={() => this.setState({ isActiveColorPicker: false })} className='active'  >
																				<span style={{ backgroundColor: this.state.bgColor }} />
																			</li>)
																		}

																		<li>
																			<span className="color-picker" id="isActiveColorPicker" style={{ backgroundColor: this.state.bgColor }} />
																		</li>

																		{this.state.isActiveColorPicker && (
																			<ChromePicker
																				color={this.state.bgColor}
																				onChange={color =>
																					this.onChangeBasicColorPicker("headerBackground", color)
																				}
																			/>
																		)
																		}

																	</ul>
																</div>
															</div>
														</div>
													</div>
													<div className="row">
														<div className="col-md-12">
															<div className="chat-feilds py-5 mx-8 mob-mx-4 borderBottom">
																<div className="form-feilds">
																	<div className="wrapperInfo w-200">
																		<div className="material-select">
																			<FormControl variant="outlined" className="material-outlined w-150">
																				<InputLabel id="widgetposition-select-outlined-label">Widget position</InputLabel>
																				<Select MenuProps={{ disableScrollLock: true }} labelId="widgetposition-select-outlined-label" id="widgetposition" name="widgetposition" value={this.state.widgetposition ? this.state.widgetposition : ""} onChange={this.updatePoition} label="Widget position">
																					<MenuItem value="left">Left</MenuItem>
																					<MenuItem value="right">Right</MenuItem>
																					<MenuItem value="center">Center</MenuItem>
																				</Select>
																			</FormControl>
																		</div>

																	</div>
																</div>
															</div>
														</div>
													</div>



													<div className="row">
														<div className="col-md-12">
															<div className="chat-feilds py-5 mx-8 mob-mx-4 borderBottom">
																<div className={`settings-feld form-feilds k-flex align-items-center mb-3`}>
																	<h6 className="card-title mb-0">Pop Up Widget</h6>
																	{this.state.activatePopUpWidget ? (<div className="mx-5 custom-switch">
																		<input type="checkbox" className="custom-control-input" id="switchWidget" name="popUpWidgetCheck" checked={this.state.activatePopUpWidget} onChange={(event) => { this.setState({ activatePopUpWidget: event.target.checked }) }} />
																		<label className="custom-control-label" htmlFor="switchWidget"></label>
																	</div>) : (<div className="mx-5 custom-switch">
																		<input type="checkbox" className="custom-control-input" id="switchWidget" name="popUpWidgetCheck" checked={this.state.activatePopUpWidget} onChange={(event) => { this.setState({ activatePopUpWidget: event.target.checked }, () => this.openPopUpMenu(this.state.popUpMenuOpened)) }} />
																		<label className="custom-control-label" htmlFor="switchWidget"></label>
																	</div>)}

																	{this.state.activatePopUpWidget ? (<div className="select-languages position-relative">
																		{this.state.languages.length > 0 ? (<><select className="customArrow cusArroLan" name="defaultLanguage" onChange={this.handleDefaultLanguage}>
																			{this.state.languages.map((value, key) => {
																				return <option value={value.lang} key={key}>{value.text}</option>
																			})}
																		</select><label className="sta-langu-label">Select Language</label></>) : (null)}
																	</div>) : null}
																</div>
																<div className='d-flex flex-wrap mob-col-rev align-items-center'>
																	<div className='imageList'>
																		<div>
																			<ul className="d-flex flex-wrap">
																				<li className={this.state.popUpMenuOpened === '1' ? 'active' : ''} onClick={() => { if (this.state.activatePopUpWidget) { this.openPopUpMenu("1") } }}>
																					<svg xmlns="http://www.w3.org/2000/svg" width="76" height="61" viewBox="0 0 76 61"> <g id="Group_13142" data-name="Group 13142" transform="translate(-318 -765)"> <rect id="Rectangle_1740" data-name="Rectangle 1740" width="76" height="61" rx="6" transform="translate(318 765)" fill="#d8d8d8" /> <g id="Group_13141" data-name="Group 13141"> <rect id="Rectangle_1741" data-name="Rectangle 1741" width="61" height="9" rx="2" transform="translate(326 810)" fill="#fff" /> <g id="Group_13132" data-name="Group 13132"> <rect id="Rectangle_1742" data-name="Rectangle 1742" width="22" height="3" rx="1.5" transform="translate(327 785)" fill="#fff" /> <rect id="Rectangle_1743" data-name="Rectangle 1743" width="13" height="3" rx="1.5" transform="translate(327 791)" fill="#fff" /> </g> <g id="Group_13133" data-name="Group 13133" transform="translate(0 -1)"> <g id="Polygon_2" data-name="Polygon 2" transform="translate(353 784)" fill="#d8d8d8"> <path d="M 14.58030128479004 14.99999618530273 L 3.419690847396851 14.99999618530273 C 2.901960849761963 14.99999618530273 2.643550872802734 14.65371608734131 2.556480884552002 14.50484561920166 C 2.46941089630127 14.35596561431885 2.29430103302002 13.96097564697266 2.548120975494385 13.50973606109619 L 8.12843132019043 3.589195728302002 C 8.387210845947266 3.129125833511353 8.824151039123535 3.079465866088867 9.000000953674316 3.079465866088867 C 9.175850868225098 3.079465866088867 9.612791061401367 3.129125833511353 9.871581077575684 3.589195728302002 L 15.45188140869141 13.50973606109619 C 15.70570087432861 13.96097564697266 15.53059101104736 14.35596561431885 15.44352054595947 14.5048360824585 C 15.3564510345459 14.65371608734131 15.09803104400635 14.99999618530273 14.58030128479004 14.99999618530273 Z" stroke="none" /> <path d="M 9 4.07945728302002 L 9.000000953674316 4.079455375671387 L 3.41969108581543 13.99999618530273 L 14.58030128479004 13.99999618530273 L 9.00001049041748 4.079475402832031 C 9.000007629394531 4.079469680786133 9.000003814697266 4.079463005065918 9 4.07945728302002 M 9.000000953674316 2.079461097717285 C 9.680423736572266 2.079461097717285 10.3608455657959 2.419285774230957 10.74315071105957 3.098936080932617 L 16.32345008850098 13.01947593688965 C 17.07339096069336 14.35268592834473 16.10996055603027 15.99999618530273 14.58030128479004 15.99999618530273 L 3.41969108581543 15.99999618530273 C 1.890041351318359 15.99999618530273 0.9266109466552734 14.35268592834473 1.676540374755859 13.01947593688965 L 7.256851196289062 3.098936080932617 C 7.639156341552734 2.419285774230957 8.319578170776367 2.079461097717285 9.000000953674316 2.079461097717285 Z" stroke="none" fill="#fff" /> </g> <g id="Polygon_1" data-name="Polygon 1" transform="translate(362 779)" fill="#d8d8d8"> <path d="M 20.55363845825195 20 L 3.446359157562256 20 C 2.926609039306641 20 2.668359041213989 19.65167999267578 2.581449031829834 19.50193023681641 C 2.494539022445679 19.35217094421387 2.320249080657959 18.95512962341309 2.578119039535522 18.50386047363281 L 11.13174915313721 3.534990549087524 C 11.3916187286377 3.080220460891724 11.8255090713501 3.03113055229187 11.99999904632568 3.03113055229187 C 12.17448902130127 3.03113055229187 12.60837936401367 3.080220460891724 12.86824893951416 3.534990549087524 L 21.42188835144043 18.50386047363281 C 21.67975997924805 18.95514106750488 21.50545883178711 19.35217094421387 21.41854858398438 19.50193023681641 C 21.33163833618164 19.65167999267578 21.07339859008789 20 20.55363845825195 20 Z" stroke="none" /> <path d="M 11.99999904632568 4.031129837036133 L 3.446359634399414 18.99999046325684 C 3.446357727050781 18.9999942779541 3.446355819702148 18.99999618530273 3.446353912353516 19 C 3.446355819702148 19 3.446357727050781 19 3.446359634399414 19 L 20.55363845825195 19 L 12.00000953674316 4.031129837036133 C 12.0000057220459 4.031129837036133 12.00000190734863 4.031129837036133 11.99999904632568 4.031129837036133 M 11.99999904632568 2.0311279296875 C 12.67629623413086 2.0311279296875 13.35259437561035 2.367034912109375 13.73648929595947 3.038850784301758 L 22.29012870788574 18.00772094726562 C 23.0520191192627 19.34103965759277 22.08928871154785 21 20.55363845825195 21 L 3.446359634399414 21 C 1.91071891784668 21 0.9479789733886719 19.34103965759277 1.709869384765625 18.00772094726562 L 10.26350879669189 3.038850784301758 C 10.64740371704102 2.367034912109375 11.32370185852051 2.0311279296875 11.99999904632568 2.0311279296875 Z" stroke="none" fill="#fff" /> </g> </g> </g> </g> </svg>
																					<p>Image Right</p>
																				</li>
																				<li className={this.state.popUpMenuOpened === '2' ? 'active' : ''} onClick={() => { if (this.state.activatePopUpWidget) { this.openPopUpMenu("2") } }}>
																					<svg xmlns="http://www.w3.org/2000/svg" width="76" height="61" viewBox="0 0 76 61"> <g id="Group_13143" data-name="Group 13143" transform="translate(-452 -765)"> <rect id="Rectangle_1746" data-name="Rectangle 1746" width="76" height="61" rx="6" transform="translate(452 765)" fill="#d8d8d8" /> <g id="Group_13140" data-name="Group 13140"> <rect id="Rectangle_1745" data-name="Rectangle 1745" width="61" height="9" rx="2" transform="translate(460 810)" fill="#fff" /> <g id="Group_13135" data-name="Group 13135" transform="translate(498 785)"> <rect id="Rectangle_1742" data-name="Rectangle 1742" width="22" height="3" rx="1.5" fill="#fff" /> <rect id="Rectangle_1743" data-name="Rectangle 1743" width="13" height="3" rx="1.5" transform="translate(9 6)" fill="#fff" /> </g> <g id="Group_13134" data-name="Group 13134" transform="translate(461 778)"> <g id="Polygon_2" data-name="Polygon 2" transform="translate(15 5)" fill="#d8d8d8"> <path d="M 14.58030128479004 14.99999618530273 L 3.419690847396851 14.99999618530273 C 2.901960849761963 14.99999618530273 2.643550872802734 14.65371608734131 2.556480884552002 14.50484561920166 C 2.46941089630127 14.35596561431885 2.29430103302002 13.96097564697266 2.548120975494385 13.50973606109619 L 8.12843132019043 3.589195728302002 C 8.387210845947266 3.129125833511353 8.824151039123535 3.079465866088867 9.000000953674316 3.079465866088867 C 9.175850868225098 3.079465866088867 9.612791061401367 3.129125833511353 9.871581077575684 3.589195728302002 L 15.45188140869141 13.50973606109619 C 15.70570087432861 13.96097564697266 15.53059101104736 14.35596561431885 15.44352054595947 14.5048360824585 C 15.3564510345459 14.65371608734131 15.09803104400635 14.99999618530273 14.58030128479004 14.99999618530273 Z" stroke="none" /> <path d="M 9 4.07945728302002 L 9.000000953674316 4.079455375671387 L 3.41969108581543 13.99999618530273 L 14.58030128479004 13.99999618530273 L 9.00001049041748 4.079475402832031 C 9.000007629394531 4.079469680786133 9.000003814697266 4.079463005065918 9 4.07945728302002 M 9.000000953674316 2.079461097717285 C 9.680423736572266 2.079461097717285 10.3608455657959 2.419285774230957 10.74315071105957 3.098936080932617 L 16.32345008850098 13.01947593688965 C 17.07339096069336 14.35268592834473 16.10996055603027 15.99999618530273 14.58030128479004 15.99999618530273 L 3.41969108581543 15.99999618530273 C 1.890041351318359 15.99999618530273 0.9266109466552734 14.35268592834473 1.676540374755859 13.01947593688965 L 7.256851196289062 3.098936080932617 C 7.639156341552734 2.419285774230957 8.319578170776367 2.079461097717285 9.000000953674316 2.079461097717285 Z" stroke="none" fill="#fff" /> </g> <g id="Polygon_1" data-name="Polygon 1" fill="#d8d8d8"> <path d="M 20.55363845825195 20 L 3.446359157562256 20 C 2.926609039306641 20 2.668359041213989 19.65167999267578 2.581449031829834 19.50193023681641 C 2.494539022445679 19.35217094421387 2.320249080657959 18.95512962341309 2.578119039535522 18.50386047363281 L 11.13174915313721 3.534990549087524 C 11.3916187286377 3.080220460891724 11.8255090713501 3.03113055229187 11.99999904632568 3.03113055229187 C 12.17448902130127 3.03113055229187 12.60837936401367 3.080220460891724 12.86824893951416 3.534990549087524 L 21.42188835144043 18.50386047363281 C 21.67975997924805 18.95514106750488 21.50545883178711 19.35217094421387 21.41854858398438 19.50193023681641 C 21.33163833618164 19.65167999267578 21.07339859008789 20 20.55363845825195 20 Z" stroke="none" /> <path d="M 11.99999904632568 4.031129837036133 L 3.446359634399414 18.99999046325684 C 3.446357727050781 18.9999942779541 3.446355819702148 18.99999618530273 3.446353912353516 19 C 3.446355819702148 19 3.446357727050781 19 3.446359634399414 19 L 20.55363845825195 19 L 12.00000953674316 4.031129837036133 C 12.0000057220459 4.031129837036133 12.00000190734863 4.031129837036133 11.99999904632568 4.031129837036133 M 11.99999904632568 2.0311279296875 C 12.67629623413086 2.0311279296875 13.35259437561035 2.367034912109375 13.73648929595947 3.038850784301758 L 22.29012870788574 18.00772094726562 C 23.0520191192627 19.34103965759277 22.08928871154785 21 20.55363845825195 21 L 3.446359634399414 21 C 1.91071891784668 21 0.9479789733886719 19.34103965759277 1.709869384765625 18.00772094726562 L 10.26350879669189 3.038850784301758 C 10.64740371704102 2.367034912109375 11.32370185852051 2.0311279296875 11.99999904632568 2.0311279296875 Z" stroke="none" fill="#fff" /> </g> </g> </g> </g> </svg>
																					<p>Image Left</p>
																				</li>
																				<li className={this.state.popUpMenuOpened === '3' ? 'active' : ''} onClick={() => { if (this.state.activatePopUpWidget) { this.openPopUpMenu("3") } }}>
																					<svg xmlns="http://www.w3.org/2000/svg" width="76" height="61" viewBox="0 0 76 61"> <g id="Group_13139" data-name="Group 13139" transform="translate(-569 -765)"> <rect id="Rectangle_1748" data-name="Rectangle 1748" width="76" height="61" rx="6" transform="translate(569 765)" fill="#d8d8d8" /> <rect id="Rectangle_1747" data-name="Rectangle 1747" width="61" height="9" rx="2" transform="translate(577 810)" fill="#fff" /> <g id="Group_13136" data-name="Group 13136" transform="translate(597 785)"> <rect id="Rectangle_1742" data-name="Rectangle 1742" width="50" height="3" rx="1.5" transform="translate(-14 -6)" fill="#fff" /> <rect id="Rectangle_1749" data-name="Rectangle 1749" width="36" height="3" rx="1.5" transform="translate(-7 2)" fill="#fff" /> <rect id="Rectangle_1750" data-name="Rectangle 1750" width="36" height="3" rx="1.5" transform="translate(-7 10)" fill="#fff" /> </g> </g> </svg>
																					<p>Text Only</p>
																				</li>
																				<li className={this.state.popUpMenuOpened === '4' ? 'active' : ''} onClick={() => { if (this.state.activatePopUpWidget) { this.openPopUpMenu("4") } }}>
																					<svg xmlns="http://www.w3.org/2000/svg" width="76" height="61" viewBox="0 0 76 61"> <g id="Group_13138" data-name="Group 13138" transform="translate(-682 -765)"> <rect id="Rectangle_1751" data-name="Rectangle 1751" width="76" height="61" rx="6" transform="translate(682 765)" fill="#d8d8d8" /> <rect id="Rectangle_1752" data-name="Rectangle 1752" width="61" height="9" rx="2" transform="translate(690 810)" fill="#fff" /> <g id="Group_13137" data-name="Group 13137" transform="translate(351 -1)"> <g id="Polygon_2" data-name="Polygon 2" transform="translate(353 784)" fill="#d8d8d8"> <path d="M 14.58030128479004 14.99999618530273 L 3.419690847396851 14.99999618530273 C 2.901960849761963 14.99999618530273 2.643550872802734 14.65371608734131 2.556480884552002 14.50484561920166 C 2.46941089630127 14.35596561431885 2.29430103302002 13.96097564697266 2.548120975494385 13.50973606109619 L 8.12843132019043 3.589195728302002 C 8.387210845947266 3.129125833511353 8.824151039123535 3.079465866088867 9.000000953674316 3.079465866088867 C 9.175850868225098 3.079465866088867 9.612791061401367 3.129125833511353 9.871581077575684 3.589195728302002 L 15.45188140869141 13.50973606109619 C 15.70570087432861 13.96097564697266 15.53059101104736 14.35596561431885 15.44352054595947 14.5048360824585 C 15.3564510345459 14.65371608734131 15.09803104400635 14.99999618530273 14.58030128479004 14.99999618530273 Z" stroke="none" /> <path d="M 9 4.07945728302002 L 9.000000953674316 4.079455375671387 L 3.41969108581543 13.99999618530273 L 14.58030128479004 13.99999618530273 L 9.00001049041748 4.079475402832031 C 9.000007629394531 4.079469680786133 9.000003814697266 4.079463005065918 9 4.07945728302002 M 9.000000953674316 2.079461097717285 C 9.680423736572266 2.079461097717285 10.3608455657959 2.419285774230957 10.74315071105957 3.098936080932617 L 16.32345008850098 13.01947593688965 C 17.07339096069336 14.35268592834473 16.10996055603027 15.99999618530273 14.58030128479004 15.99999618530273 L 3.41969108581543 15.99999618530273 C 1.890041351318359 15.99999618530273 0.9266109466552734 14.35268592834473 1.676540374755859 13.01947593688965 L 7.256851196289062 3.098936080932617 C 7.639156341552734 2.419285774230957 8.319578170776367 2.079461097717285 9.000000953674316 2.079461097717285 Z" stroke="none" fill="#fff" /> </g> <g id="Polygon_1" data-name="Polygon 1" transform="translate(362 779)" fill="#d8d8d8"> <path d="M 20.55363845825195 20 L 3.446359157562256 20 C 2.926609039306641 20 2.668359041213989 19.65167999267578 2.581449031829834 19.50193023681641 C 2.494539022445679 19.35217094421387 2.320249080657959 18.95512962341309 2.578119039535522 18.50386047363281 L 11.13174915313721 3.534990549087524 C 11.3916187286377 3.080220460891724 11.8255090713501 3.03113055229187 11.99999904632568 3.03113055229187 C 12.17448902130127 3.03113055229187 12.60837936401367 3.080220460891724 12.86824893951416 3.534990549087524 L 21.42188835144043 18.50386047363281 C 21.67975997924805 18.95514106750488 21.50545883178711 19.35217094421387 21.41854858398438 19.50193023681641 C 21.33163833618164 19.65167999267578 21.07339859008789 20 20.55363845825195 20 Z" stroke="none" /> <path d="M 11.99999904632568 4.031129837036133 L 3.446359634399414 18.99999046325684 C 3.446357727050781 18.9999942779541 3.446355819702148 18.99999618530273 3.446353912353516 19 C 3.446355819702148 19 3.446357727050781 19 3.446359634399414 19 L 20.55363845825195 19 L 12.00000953674316 4.031129837036133 C 12.0000057220459 4.031129837036133 12.00000190734863 4.031129837036133 11.99999904632568 4.031129837036133 M 11.99999904632568 2.0311279296875 C 12.67629623413086 2.0311279296875 13.35259437561035 2.367034912109375 13.73648929595947 3.038850784301758 L 22.29012870788574 18.00772094726562 C 23.0520191192627 19.34103965759277 22.08928871154785 21 20.55363845825195 21 L 3.446359634399414 21 C 1.91071891784668 21 0.9479789733886719 19.34103965759277 1.709869384765625 18.00772094726562 L 10.26350879669189 3.038850784301758 C 10.64740371704102 2.367034912109375 11.32370185852051 2.0311279296875 11.99999904632568 2.0311279296875 Z" stroke="none" fill="#fff" /> </g> </g> </g> </svg>
																					<p>Image Only</p>
																				</li>
																			</ul>
																		</div>
																		{this.state.activatePopUpWidget === true ?
																			(<>
																				<div id="imageRight" className="tabcontent" style={{ display: 'none' }}>
																					<div className='color-picker mt-4'>
																						<label htmlFor="backgroundColorPopUp1">Background Color</label>
																						<div className='d-flex flex-wrap'>
																							<span className='picker-input'>
																								<input type="color" id="backgroundColorPopUp1" name="backgroundColorPopUp1" defaultValue={this.state.popUpBackgroundColor} onChange={(event) => this.setState({ popUpBackgroundColor: event.target.value })} />
																								{this.state.popUpBackgroundColor}
																							</span>
																							<span className='picker-text'>
																								<input type="checkbox" id="sameBackgroundColor1" name="sameBackgroundColor1" defaultValue={this.state.userbgColor} onClick={(event) => this.handleOnClick(event)} />
																								<label htmlFor="sameBackgroundColor1">Same as theme color</label>
																							</span>
																						</div>

																					</div>

																					<div className="form-feilds">
																						<div className="input-group material-input mb-5 mt-4">
																							<label htmlFor="popUpMessage1">Message</label>
																							{this.state.defaultLanguage === 'ar' ? (<TextField dir="rtl" lang="ar" className="form-control w-100" rows={4} id="popUpMessage1" variant="outlined" name="popUpMessage1" placeholder={this.state.defaultMessagePlaceholder} defaultValue={this.state.popUpMessage} multiline onChange={(event) => { this.setState({ popUpMessage: event.target.value }) }} />) :
																								(<TextField className="form-control w-100" rows={4} id="popUpMessage1" variant="outlined" name="popUpMessage1" placeholder={this.state.defaultMessagePlaceholder} defaultValue={this.state.popUpMessage} multiline onChange={(event) => { this.setState({ popUpMessage: event.target.value }) }} />)}
																							<p className="error">{this.state.popUpMessageError}</p>
																						</div>

																						<div className="upload-view">
																							<label htmlFor="popUpImage1">Image:</label>
																							<div className='upload-box mb-3'>
																								{backgroundImageUploading}
																								<span className='upImg-view'>
																									{this.state.showPopUpImagePreview ? (<img id="popUpImagePreview1" src={this.state.popUpImageSrc} alt="Your image" />) : (null)}
																									<span className='up-icon'>+</span>
																									Drag & Drop or <span>Click</span> to upload a image
																								</span>

																								<input type="file" id="popUpImage1" name="popUpImage1" accept="image/png, image/jpeg, , image/jpg, image/bmp" onChange={(event) => { this.showPopUpImage(event, "popUpImagePreview1", "popUpImage1", this.state.placeholdImageSrc, 200, 200) }} />
																								<a className='delete-btn' onClick={() => { try { document.getElementById("popUpImage1").value = ""; document.getElementById("popUpImagePreview1").src = this.state.placeholdImageSrc; this.setState({ showPopUpImagePreview: false, popUpImageSrc: this.state.placeholdImageSrc }) } catch (e) { } }}>
																									<img id="popUpImageDelete1" src={require('../../../assets/img/icon/delete-new.svg')} alt="Delete" />
																								</a>
																							</div>
																							<small>Maximum size is 1 MB. Recommended dimensions is 100x100px. </small>
																							<small>To support retina displays, recommended dimensions is 200x200px.</small>
																						</div>

																					</div>

																				</div>

																				<div id="imageLeft" className="tabcontent" style={{ display: 'none' }}>
																					<div className='color-picker mt-4'>
																						<label htmlFor="backgroundColorPopUp2">Background Color</label>
																						<div className='d-flex flex-wrap'>
																							<span className='picker-input'>
																								{/* {this.state.isActiveColorPicker1 && (<ChromePicker id="backgroundColorPopUp1" name="backgroundColorPopUp1" color={this.state.popUpBackgroundColor} onChange={color => this.setState({ popUpBackgroundColor: color.hex })}/>)} */}
																								<input type="color" id="backgroundColorPopUp2" name="backgroundColorPopUp2" defaultValue={this.state.popUpBackgroundColor} onChange={(event) => this.setState({ popUpBackgroundColor: event.target.value })} />
																								{this.state.popUpBackgroundColor}
																							</span>
																							<span className='picker-text'>
																								<input type="checkbox" id="sameBackgroundColor2" name="sameBackgroundColor2" defaultValue={this.state.userbgColor} onClick={(event) => this.handleOnClick(event)} />
																								<label htmlFor="sameBackgroundColor2">Same as theme color</label>
																							</span>
																						</div>
																					</div>


																					<div className="form-feilds">
																						<div className="input-group material-input mb-5 mt-4">
																							<label htmlFor="popUpMessage2">Message</label>
																							{this.state.defaultLanguage === 'ar' ? (<TextField dir="rtl" lang="ar" className="form-control w-100" rows={4} id="popUpMessage2" variant="outlined" name="popUpMessage2" placeholder={this.state.defaultMessagePlaceholder} defaultValue={this.state.popUpMessage} multiline onChange={(event) => { this.setState({ popUpMessage: event.target.value }) }} />) :
																								(<TextField className="form-control w-100" rows={4} id="popUpMessage2" variant="outlined" name="popUpMessage2" placeholder={this.state.defaultMessagePlaceholder} defaultValue={this.state.popUpMessage} multiline onChange={(event) => { this.setState({ popUpMessage: event.target.value }) }} />)}
																							<p className="error">{this.state.popUpMessageError}</p>
																						</div>
																						<div className="upload-view bb">
																							<label htmlFor="popUpImage2">Image:</label>
																							<div className='upload-box mb-3'>
																								{backgroundImageUploading}
																								<span className='upImg-view'>
																									{this.state.showPopUpImagePreview ? (<img id="popUpImagePreview2" src={this.state.popUpImageSrc} alt="Your image" />) : (null)}
																									<span className='up-icon'>+</span>
																									Drag & Drop or <span>Click</span> to upload a image
																								</span>

																								<input type="file" id="popUpImage2" name="popUpImage2" accept="image/png, image/jpeg, , image/jpg, image/bmp" onChange={(event) => { this.showPopUpImage(event, "popUpImagePreview2", "popUpImage2", this.state.placeholdImageSrc, 200, 200) }} />
																								<a className='delete-btn' onClick={() => { try { document.getElementById("popUpImage2").value = ""; document.getElementById("popUpImagePreview2").src = this.state.placeholdImageSrc; this.setState({ showPopUpImagePreview: false, popUpImageSrc: this.state.placeholdImageSrc }) } catch (e) { } }}>
																									<img id="popUpImageDelete2" src={require('../../../assets/img/icon/delete-new.svg')} alt="Delete" />
																								</a>
																							</div>
																							<small>Maximum size is 1 MB. Recommended dimensions is 100x100px. </small>
																							<small>To support retina displays, recommended dimensions is 200x200px.</small>
																						</div>
																					</div>
																				</div>

																				<div id="textOnly" className="tabcontent" style={{ display: 'none' }}>
																					<div className='color-picker mt-4'>
																						<label htmlFor="backgroundColorPopUp3">Background Color</label>
																						<div className='d-flex flex-wrap'>
																							<span className='picker-input'>
																								<input type="color" id="backgroundColorPopUp3" name="backgroundColorPopUp3" defaultValue={this.state.popUpBackgroundColor} onChange={(event) => this.setState({ popUpBackgroundColor: event.target.value })} />
																								{this.state.popUpBackgroundColor}
																							</span>
																							<span className='picker-text'>
																								<input type="checkbox" id="sameBackgroundColor3" name="sameBackgroundColor3" defaultValue={this.state.userbgColor} onClick={(event) => this.handleOnClick(event)} />
																								<label htmlFor="sameBackgroundColor3">Same as theme color</label>
																							</span>
																						</div>
																					</div>

																					<div className="form-feilds">
																						<div className="input-group material-input mb-5 mt-4">
																							<label htmlFor="popUpMessage3">Message</label>
																							{this.state.defaultLanguage === 'ar' ? (<TextField dir="rtl" lang="ar" className="form-control w-100" rows={4} id="popUpMessage3" variant="outlined" name="popUpMessage3" placeholder={this.state.defaultMessagePlaceholder} defaultValue={this.state.popUpMessage} multiline onChange={(event) => { this.setState({ popUpMessage: event.target.value }) }} />) :
																								(<TextField className="form-control w-100" rows={4} id="popUpMessage3" variant="outlined" name="popUpMessage3" placeholder={this.state.defaultMessagePlaceholder} defaultValue={this.state.popUpMessage} multiline onChange={(event) => { this.setState({ popUpMessage: event.target.value }) }} />)}
																							<p className="error">{this.state.popUpMessageError}</p>
																						</div>

																					</div>
																				</div>

																				<div id="imageOnly" className="tabcontent" style={{ display: 'none' }}>
																					<div className='color-picker mt-4'>
																						<label htmlFor="backgroundColorPopUp4">Background Color</label>
																						<div className='d-flex flex-wrap'>
																							<span className='picker-input'>
																								<input type="color" id="backgroundColorPopUp4" name="backgroundColorPopUp4" defaultValue={this.state.popUpBackgroundColor} onChange={(event) => this.setState({ popUpBackgroundColor: event.target.value })} />
																								{this.state.popUpBackgroundColor}
																							</span>
																							<span className='picker-text'>
																								<input type="checkbox" id="sameBackgroundColor4" name="sameBackgroundColor4" defaultValue={this.state.userbgColor} onClick={(event) => this.handleOnClick(event)} />
																								<label htmlFor="sameBackgroundColor4">Same as theme color</label>
																							</span>
																						</div>
																					</div>

																					<div className="form-feilds">

																						<div className="upload-view">
																							<label htmlFor="popUpImage4">Image:</label>
																							<div className='upload-box mb-3'>
																								{backgroundImageUploading}
																								<span className='upImg-view'>
																									{this.state.showPopUpImagePreview ? (<img id="popUpImagePreview4" src={this.state.popUpImageSrc} alt="Your image" />) : (null)}
																									<span className='up-icon'>+</span>
																									Drag & Drop or <span>Click</span> to upload a image
																								</span>

																								<input type="file" id="popUpImage4" name="popUpImage4" accept="image/png, image/jpeg, , image/jpg, image/bmp" onChange={(event) => { this.showPopUpImage(event, "popUpImagePreview4", "popUpImage4", this.state.placeholdImageSrc, 480, 328) }} />
																								<a className='delete-btn' onClick={() => { try { document.getElementById("popUpImage4").value = ""; document.getElementById("popUpImagePreview4").src = this.state.placeholdImageSrc; this.setState({ showPopUpImagePreview: false, popUpImageSrc: this.state.placeholdImageSrc }) } catch (e) { } }}>
																									<img id="popUpImageDelete4" src={require('../../../assets/img/icon/delete-new.svg')} alt="Delete" />
																								</a>
																							</div>
																							<small>Maximum size is 1 MB. Recommended dimensions is 240x164px. </small>
																							<small>To support retina displays, recommended dimensions is 480x328px.</small>
																						</div>
																					</div>
																				</div>
																			</>) : (null)}
																	</div>
																	{this.state.activatePopUpWidget === true ? (<>
																		<div className='text-img-view'>
																			{this.state.popUpMenuOpened === '1' ?
																				(<div className='default-view' id="popUpDiv1" contentEditable="false" style={{ backgroundColor: this.state.popUpBackgroundColor }} suppressContentEditableWarning='true'>
																					<span className='default-head'>{this.state.headerText}</span>
																					<div className='d-flex flex-wrap view px-5 py-4 align-items-center'>
																						<p>{this.state.popUpMessage ? this.state.popUpMessage : this.state.defaultMessagePlaceholder}</p>
																						<img id="popUpImageMessageId1" src={this.state.popUpImageSrc} alt="Your image" />
																					</div>
																					<div className='inputView'>
																						{this.state.popUpWidgetPlaceholder}
																						<img src={require('./../../../assets/img/icon/send-icon.svg')} alt='send icon' />
																					</div>
																				</div>) :
																				(this.state.popUpMenuOpened === '2' ?
																					(<div className='default-view' id="popUpDiv2" contentEditable="false" style={{ backgroundColor: this.state.popUpBackgroundColor }} suppressContentEditableWarning='true'>
																						<span className='default-head'>{this.state.headerText}</span>
																						<div className='d-flex flex-wrap view px-5 py-4 align-items-center'>
																							<img id="popUpImageMessageId2" src={this.state.popUpImageSrc} alt="Your image" />
																							<p className='d-flex'> {this.state.popUpMessage ? this.state.popUpMessage : this.state.defaultMessagePlaceholder}</p>
																						</div>
																						<div className='inputView'>
																							{this.state.popUpWidgetPlaceholder}
																							<img src={require('./../../../assets/img/icon/send-icon.svg')} alt='send icon' />
																						</div>
																					</div>) :
																					(this.state.popUpMenuOpened === '3' ?
																						(<div className='default-view' id="popUpDiv3" contentEditable="false" style={{ backgroundColor: this.state.popUpBackgroundColor }} suppressContentEditableWarning='true'>
																							<span className='default-head'>{this.state.headerText}</span>
																							<div className='view px-5 py-4'>
																								<p> {this.state.popUpMessage ? this.state.popUpMessage : this.state.defaultMessagePlaceholder}</p>
																							</div>
																							<div className='inputView'>
																								{this.state.popUpWidgetPlaceholder}
																								<img src={require('./../../../assets/img/icon/send-icon.svg')} alt='send icon' />
																							</div>

																						</div>) :
																						(this.state.popUpMenuOpened === '4' ?
																							(<div className='default-view' id="popUpDiv4" contentEditable="false" style={{ backgroundColor: this.state.popUpBackgroundColor }} suppressContentEditableWarning='true'>
																								<span className='default-head'>{this.state.headerText}</span>
																								<div className='view px-5 py-4'>
																									<img id="popUpImageMessageId4" src={this.state.popUpImageSrc} alt="Your image" style={{ width: 'auto', height: '50px' }} />
																								</div>
																								<div className='inputView'>
																									{this.state.popUpWidgetPlaceholder}
																									<img src={require('./../../../assets/img/icon/send-icon.svg')} alt='send icon' />
																								</div>
																							</div>) :
																							(null)
																						)
																					)
																				)
																			}
																		</div>
																	</>) : (null)}

																</div>

																{/* </div> */}
																{/* </div> */}
															</div>
														</div>
													</div>


												</div>) : (null)}

												<div className="perfect Feilds mob-px-4 accordian-view">
													{this.state.showAdvancedSettings ? (<h4 className="heding-text px-4 py-4 position-relative" onClick={() => this.changeSettings(false)}>Advance Settings <span className="down-arrow"></span></h4>
														// <div className="settings-form-feilds">
														//     <div className="settings-feld form-feilds k-flex align-items-center">
														//         <span className="main-checkbox-all"><label className="containerRadio containerafterchecked">
														//             <input type="radio" name="set_default_settings" defaultValue="false" onChange={() => this.changeSettings(false)} checked={!this.state.showbasicSettings ? true : false} />
														//             <span className="radioCheckmark" /></label></span>
														//         
														//     </div>
														// </div>
													) : (null)}

												</div>
												{!this.state.showbasicSettings ? (<div className="chat-forems-section">
													{/* <div className="chat-feilds py-5 mx-8 mob-mx-4">
														<div className="form-feilds">
															<div className="input-group material-input">
																<TextField className="form-control w-100" variant="outlined" name="headerText" value={this.state.headerText} onChange={this.headerChange} label="Header Name" /> */}
													{/* <h4 className="heding-text">Header Name</h4>
                                                                <input type="text" placeholder="Header Name" name="headerText" value={this.state.headerText} onChange={this.headerChange} /> */}
													{/* <p className="error">{this.state.headertext_error}</p>
															</div>
														</div>
													</div> */}
													<div className="py-5 mx-8 borderBottom mob-mx-4">
														<div className="row">
															<div className="col-xs-12 col-sm-6 col-md-6 form-feilds">
																<div className="settings-feld">
																	<h6 className="card-title mb-0">Header Background Color</h6>
																</div>
																<div className="wrapperInfo colorwrapperInfo">
																	<div className="color-feilds k-flex align-items-center" onClick={() => { this.showColorPicker('isActivehbColorPicker') }}>
																		<span className="mr-4 color-picker" id="isActivehbColorPicker" style={{ background: this.state.headerbgColor }}>

																		</span>
																		<p className="card-body-text">{this.state.headerbgColor}</p>
																	</div>
																	{this.state.isActivehbColorPicker && (
																		<ChromePicker
																			color={this.state.headerbgColor}
																			onChange={color =>
																				this.onChangeColorPicker("headerbgColor", color)
																			}
																		/>
																	)}
																</div>
															</div>
															<div className="col-xs-12 col-sm-6 col-md-6 form-feilds">
																<div className="settings-feld">
																	<h6 className="card-title mb-0">Header Text Color</h6>
																</div>
																<div className="wrapperInfo colorwrapperInfo">
																	<div className="color-feilds k-flex align-items-center" onClick={() => { this.showColorPicker('isActiveheadertextPicker') }}>
																		<span className="mr-4 color-picker" style={{ background: this.state.headerTextColor }}>
																		</span>
																		<p className="card-body-text">{this.state.headerTextColor}</p>
																	</div>
																	{this.state.isActiveheadertextPicker && (
																		<ChromePicker
																			color={this.state.headerTextColor}
																			onChange={color =>
																				this.onChangeColorPicker("headerTextColor", color)
																			}
																		/>
																	)}
																</div>
															</div>
														</div>
													</div>
													<div className="row">
														<div className="col-md-12 col-xs-12">
															<div className="chat-feilds py-5 mx-8 mob-mx-4 borderBottom">
																<div className="widget-brandLogo widget-sec">
																	<h5 className="card-title mb-0">Brand Logo</h5>
																	<ul className="pt-3">
																		{
																			this.state.brand_logos.map((item, i) =>
																			(

																				(<li
																					className={
																						this.state.brand_logo === item
																							? "active"
																							: ""
																					}
																					onClick={() => this.changebrandImage(item)} key={i}>
																					{/* <span><img src={`${item.blackImage}`} alt="" /></span> */}
																					<span><img src={item} alt="" /></span>


																				</li>)
																				// <li><span><img src={require('./../../assets/images/widget/chat_bubbles.svg')} alt /></span></li>
																				// <li><span><img src={require('./../../assets/images/widget/comments.svg')} alt /></span></li>

																			)
																			)
																		}
																		{brandLogoUploading}
																		<li className="lastes"><span className="agent-rightpanel-feilds position-relative">
																			<input type="file" className="w-100" accept="image/*" id="add_brand_logo" name="add_brand_logo" onChange={this.uploadBrandLogo} />
																			<span className="k-flex align-items-center mt-1">
																				<svg xmlns="http://www.w3.org/2000/svg" width="18.202" height="18.199" viewBox="0 0 18.202 18.199">
																					<path id="Icon_awesome-upload" data-name="Icon awesome-upload" d="M10.523,13.654H7.679a.851.851,0,0,1-.853-.853V6.828H3.708a.71.71,0,0,1-.5-1.212L8.614.205a.689.689,0,0,1,.971,0L15,5.616a.71.71,0,0,1-.5,1.212H11.376V12.8A.851.851,0,0,1,10.523,13.654ZM18.2,13.37v3.982a.851.851,0,0,1-.853.853H.853A.851.851,0,0,1,0,17.352V13.37a.851.851,0,0,1,.853-.853H5.688V12.8a1.992,1.992,0,0,0,1.991,1.991h2.844A1.992,1.992,0,0,0,12.514,12.8v-.284h4.835A.851.851,0,0,1,18.2,13.37ZM13.794,16.5a.711.711,0,1,0-.711.711A.713.713,0,0,0,13.794,16.5Zm2.275,0a.711.711,0,1,0-.711.711A.713.713,0,0,0,16.069,16.5Z" transform="translate(0 -0.005)" fill="#fff" />
																				</svg>
																			</span>
																		</span></li>
																	</ul>
																</div>
															</div>
														</div>
													</div>
													<div className="py-5 mx-8 mob-mx-4 borderBottom">
														<div className="row">
															<div className="col-md-12 col-xs-12">
																<div className="chat-feilds k-flex align-items-center">
																	<div className="settings-feld">
																		<h5 className="card-title mb-0">Background</h5>
																	</div>
																	<div className="backgrounds-color-tab pl-5">
																		<span className={!this.state.showGradient ? 'active' : ''} onClick={() => this.changeToGradient(false)}>Color</span>
																		<span className={this.state.showGradient ? 'active' : ''} onClick={() => this.changeToGradient(true)}>Gradient</span>
																	</div>
																</div>
															</div>

															{!this.state.showGradient ? (<div className="col-md-12 col-xs-12">
																<div className="chat-feilds py-3">
																	<div className="settings-feld">
																		{/* <h6 className="card-title mb-0">Chat Background Color</h6> */}
																	</div><div className="wrapperInfo colorwrapperInfo">
																		<div className="color-feilds k-flex align-items-center" onClick={() => { this.showColorPicker('isActivechatbgPicker') }}>
																			<span className="mr-4 color-picker" style={{ background: this.state.chatbgColor }}>
																			</span>
																			<p className="card-body-text">{this.state.chatbgColor}</p>
																		</div>
																		{this.state.isActivechatbgPicker && (
																			<ChromePicker
																				color={this.state.chatbgColor}
																				onChange={color =>
																					this.onChangeColorPicker("chatbgColor", color)
																				}
																			/>
																		)}
																	</div></div>
															</div>) : (null)}


															{this.state.showGradient ? (<><div className="col-md-6 col-xs-12">
																<div className="chat-feilds py-3">
																	<div className="settings-feld">
																		<h6 className="card-title mb-0">From Color</h6>
																	</div>
																	<div className="wrapperInfo colorwrapperInfo">
																		<div className="color-feilds k-flex align-items-center" onClick={() => { this.showColorPicker('isActivechatbgfromPicker') }}>
																			<span className="mr-4 color-picker" style={{ background: this.state.chatbgfromColor }}>
																			</span>
																			<p className="card-body-text">{this.state.chatbgfromColor}</p>
																		</div>
																		{this.state.isActivechatbgfromPicker && (
																			<ChromePicker
																				color={this.state.chatbgfromColor}
																				onChange={color =>
																					this.onChangeColorPicker("chatbgfromColor", color)
																				}
																			/>
																		)}
																	</div>
																</div>
															</div><div className="col-md-6 col-xs-12">
																	<div className="chat-feilds py-3">
																		<div className="settings-feld">
																			<h6 className="card-title mb-0">To Color</h6>
																		</div>
																		<div className="wrapperInfo colorwrapperInfo">
																			<div className="color-feilds k-flex align-items-center" onClick={() => { this.showColorPicker('isActivechatbgToPicker') }}>
																				<span className="mr-4" style={{ background: this.state.chatbgtoColor }}>
																				</span>
																				<p className="card-body-text">{this.state.chatbgtoColor}</p>
																			</div>
																			{this.state.isActivechatbgToPicker && (
																				<ChromePicker
																					color={this.state.chatbgtoColor}
																					onChange={color =>
																						this.onChangeColorPicker("chatbgtoColor", color)
																					}
																				/>
																			)}
																		</div>
																	</div>
																</div></>) : (null)}


														</div>
													</div>
													<div className="py-5 mx-8 mob-mx-4 borderBottom">
														<div className="row">
															<div className="col-md-12 col-xs-12">
																<h5 className="card-title mb-0">Chat bubbles</h5>
															</div>
															<div className="col-md-6 col-xs-12">
																<div className="chat-feilds py-3">
																	<div className="settings-feld">
																		<h6 className="card-title mb-0">Agent/form message background color</h6>
																	</div>
																	<div className="wrapperInfo colorwrapperInfo">
																		<div className="color-feilds k-flex align-items-center" onClick={() => { this.showColorPicker('isActiveagentbgPicker') }}>
																			<span className="mr-4" style={{ background: this.state.agentbgColor }}>
																			</span>
																			<p className="card-body-text">{this.state.agentbgColor}</p>
																		</div>
																		{this.state.isActiveagentbgPicker && (
																			<ChromePicker
																				color={this.state.agentbgColor}
																				onChange={color =>
																					this.onChangeColorPicker("agentbgColor", color)
																				}
																			/>
																		)}
																	</div>
																</div>
															</div>
															<div className="col-md-6 col-xs-12">
																<div className="chat-feilds py-3">
																	<div className="settings-feld">
																		<h6 className="card-title mb-0">Agent/form message text color</h6>
																	</div>
																	<div className="wrapperInfo colorwrapperInfo">
																		<div className="color-feilds k-flex align-items-center" onClick={() => { this.showColorPicker('isActiveagenttextPicker') }}>
																			<span className="mr-4" style={{ background: this.state.agentTextColor }}>
																			</span>
																			<p className="card-body-text">{this.state.agentTextColor}</p>
																		</div>
																		{this.state.isActiveagenttextPicker && (
																			<ChromePicker
																				color={this.state.agentTextColor}
																				onChange={color =>
																					this.onChangeColorPicker("agentTextColor", color)
																				}
																			/>
																		)}
																	</div>
																</div>
															</div>
															<div className="col-md-6 col-xs-12">
																<div className="chat-feilds py-3">
																	<div className="settings-feld">
																		<h6 className="card-title mb-0">User message background color</h6>
																	</div>
																	<div className="wrapperInfo colorwrapperInfo">
																		<div className="color-feilds k-flex align-items-center" onClick={() => { this.showColorPicker('isActiveuserbgPicker') }}>
																			<span className="mr-4" style={{ background: this.state.userbgColor }}>
																			</span>
																			<p className="card-body-text">{this.state.userbgColor}</p>
																		</div>
																		{this.state.isActiveuserbgPicker && (
																			<ChromePicker
																				color={this.state.userbgColor}
																				onChange={color =>
																					this.onChangeColorPicker("userbgColor", color)
																				}
																			/>
																		)}
																	</div>
																</div>
															</div>
															<div className="col-md-6 col-xs-12">
																<div className="chat-feilds py-3">
																	<div className="settings-feld">
																		<h6 className="card-title mb-0">User message text color</h6>
																	</div>
																	<div className="wrapperInfo colorwrapperInfo">
																		<div className="color-feilds k-flex align-items-center" onClick={() => { this.showColorPicker('isActiveusertextPicker') }}>
																			<span className="mr-4" style={{ background: this.state.usertextColor }}>
																			</span>
																			<p className="card-body-text">{this.state.usertextColor}</p>
																		</div>
																		{this.state.isActiveusertextPicker && (
																			<ChromePicker
																				color={this.state.usertextColor}
																				onChange={color =>
																					this.onChangeColorPicker("usertextColor", color)
																				}
																			/>
																		)}
																	</div>
																</div>
															</div>
														</div>
													</div>
													<div className="row">
														<div className="col-md-12 col-xs-12">
															<div className="chat-feilds py-5 mx-8 mob-mx-4 borderBottom">
																<div className="settings-feld">
																	<h6 className="card-title mb-0">Send Button Color</h6>
																</div>
																<div className="wrapperInfo colorwrapperInfo">
																	<div className="color-feilds k-flex align-items-center" onClick={() => { this.showColorPicker('isActivesendbtnPicker') }}>
																		<span className="mr-4" style={{ background: this.state.sendButtonColor }}>
																		</span>
																		<p className="card-body-text">{this.state.sendButtonColor}</p>
																	</div>
																	{this.state.isActivesendbtnPicker && (
																		<ChromePicker
																			color={this.state.sendButtonColor}
																			onChange={color =>
																				this.onChangeColorPicker("sendButtonColor", color)
																			}
																		/>
																	)}
																</div>
															</div>
														</div>
													</div>
													<div className="py-5 mx-8 mob-mx-4 borderBottom">
														<div className="row">
															<div className="col-md-4 col-xs-12">
																<div className="chat-feilds py-3">
																	<div className="widget-badge widget-sec ">
																		<div className="settings-feld">
																			<h5 className="card-title mb-0">Widget badge icon</h5>
																		</div>
																		<ul className="pt-3">
																			{
																				this.state.widgetImages.map((item, i) =>
																				(

																					(<li
																						className={
																							this.state.widgetImage.blackImage === item.blackImage && !this.state.avatarActive
																								? "active"
																								: ""
																						}
																						onClick={() => this.changeChatImage(item)} key={i}>
																						<span><img src={`${item.blackImage}`} alt="" /></span>
																						{/* <span><img src={item} alt="" /></span> */}


																					</li>)
																					// <li><span><img src={require('./../../assets/images/widget/chat_bubbles.svg')} alt /></span></li>
																					// <li><span><img src={require('./../../assets/images/widget/comments.svg')} alt /></span></li>

																				)
																				)
																			}
																			{badgeLogoUploading}
																			<li className="lastes">
																				<span className="agent-rightpanel-feilds position-relative">
																					<input type="file" className="w-100" id="add_badge_image" accept="image/*" name="add_badge_image" onChange={this.uploadbadgeImage} />
																					<span className="k-flex align-items-center mt-1">
																						<svg xmlns="http://www.w3.org/2000/svg" width="18.202" height="18.199" viewBox="0 0 18.202 18.199">
																							<path id="Icon_awesome-upload" data-name="Icon awesome-upload" d="M10.523,13.654H7.679a.851.851,0,0,1-.853-.853V6.828H3.708a.71.71,0,0,1-.5-1.212L8.614.205a.689.689,0,0,1,.971,0L15,5.616a.71.71,0,0,1-.5,1.212H11.376V12.8A.851.851,0,0,1,10.523,13.654ZM18.2,13.37v3.982a.851.851,0,0,1-.853.853H.853A.851.851,0,0,1,0,17.352V13.37a.851.851,0,0,1,.853-.853H5.688V12.8a1.992,1.992,0,0,0,1.991,1.991h2.844A1.992,1.992,0,0,0,12.514,12.8v-.284h4.835A.851.851,0,0,1,18.2,13.37ZM13.794,16.5a.711.711,0,1,0-.711.711A.713.713,0,0,0,13.794,16.5Zm2.275,0a.711.711,0,1,0-.711.711A.713.713,0,0,0,16.069,16.5Z" transform="translate(0 -0.005)" fill="#fff" />
																						</svg>
																					</span>
																				</span>
																			</li>
																		</ul>
																	</div>
																</div>
															</div>
															<div className="col-md-4 col-xs-12">
																<div className="chat-feilds py-3">
																	<div className="settings-feld">
																		<h5 className="card-title mb-0">Widget background Color</h5>
																	</div>
																	<div className="wrapperInfo colorwrapperInfo">
																		<div className="color-feilds k-flex align-items-center" onClick={() => { this.showColorPicker('isActivewidgetbgPicker') }}>
																			<span className="mr-4" style={{ background: this.state.widgetbgColor }}>
																			</span>
																			<p className="card-body-text">{this.state.widgetbgColor}</p>
																		</div>
																		{this.state.isActivewidgetbgPicker && (
																			<ChromePicker
																				color={this.state.widgetbgColor}
																				onChange={color =>
																					this.onChangeColorPicker("widgetbgColor", color)
																				}
																			/>
																		)}
																	</div>
																</div>
															</div>

															{/* Widget Avatar */}

															<div className="col-md-4 col-xs-12">
																<div className="chat-feilds py-3">
																	<div className="widget-badge widget-sec ">
																		<div className="settings-feld">
																			<h5 className="card-title mb-0">Widget Avatar </h5>
																		</div>
																		<ul className="pt-3 avatarImg">
																			{
																				this.state.widgetAvatar.length > 0 ? this.removeDuplicates(this.state.widgetAvatar,'blackImage').map((item, i) =>
																				{

																					return (<li
																						className={
																							this.state.AvtarImg.blackImage === item.blackImage && this.state.avatarActive
																								? "active"
																								: ""
																						}
																						onClick={() => this.changeChatImage(item, "Avatar")} key={i}>
																						<span><img src={`${item.blackImage}`} alt="" />{console.log("item", item)}</span>
																					</li>)

																					}
																				) : null
																			}
																			{avatarUploading}
																			<li className="lastes">
																				<span className="agent-rightpanel-feilds position-relative">
																					<input type="file" className="w-100" id="add_badge_avatar" accept="image/*" name="add_badge_avatar" onChange={this.uploadbadgeImage} />
																					<span className="k-flex align-items-center mt-1">
																						<svg xmlns="http://www.w3.org/2000/svg" width="18.202" height="18.199" viewBox="0 0 18.202 18.199">
																							<path id="Icon_awesome-upload" data-name="Icon awesome-upload" d="M10.523,13.654H7.679a.851.851,0,0,1-.853-.853V6.828H3.708a.71.71,0,0,1-.5-1.212L8.614.205a.689.689,0,0,1,.971,0L15,5.616a.71.71,0,0,1-.5,1.212H11.376V12.8A.851.851,0,0,1,10.523,13.654ZM18.2,13.37v3.982a.851.851,0,0,1-.853.853H.853A.851.851,0,0,1,0,17.352V13.37a.851.851,0,0,1,.853-.853H5.688V12.8a1.992,1.992,0,0,0,1.991,1.991h2.844A1.992,1.992,0,0,0,12.514,12.8v-.284h4.835A.851.851,0,0,1,18.2,13.37ZM13.794,16.5a.711.711,0,1,0-.711.711A.713.713,0,0,0,13.794,16.5Zm2.275,0a.711.711,0,1,0-.711.711A.713.713,0,0,0,16.069,16.5Z" transform="translate(0 -0.005)" fill="#fff" />
																						</svg>
																					</span>
																				</span>
																			</li>
																		</ul>
																	</div>
																</div>
															</div>


														</div>
													</div>
													<div className="py-5 mx-8 mob-mx-4 borderBottom dd">
														<div className="row">
															<div className="col-md-4 col-xs-12">
																<div className="chat-feilds py-3">
																	<div className="material-select">
																		<FormControl variant="outlined" className="material-outlined w-150">
																			<InputLabel id="widgetposition-select-outlined-label">Widget position</InputLabel>
																			<Select MenuProps={{ disableScrollLock: true }} labelId="widgetposition-select-outlined-label" id="widgetposition" name="widgetposition" value={this.state.widgetposition ? this.state.widgetposition : ""} onChange={this.updatePoition} label="Widget position">
																				<MenuItem value="left">Left</MenuItem>
																				<MenuItem value="right">Right</MenuItem>
																				<MenuItem value="center">Center</MenuItem>
																			</Select>
																		</FormControl>
																	</div>
																	{/* <div className="settings-feld">
                                                                        <h6 className="card-title mb-0">Widget Position</h6>
                                                                    </div>
                                                                     <div className="wrapperInfo">
                                                                        <select className="customArrow" name="widgetposition" value={this.state.widgetposition} onChange={this.updatePoition}>
                                                                            <option value="left">Left</option>
                                                                            <option value="right">Right</option>
                                                                            <option value="center">Center</option>
                                                                        </select>
                                                                    </div> */}
																</div>
															</div>
															<div className="col-md-4 col-xs-12 z-index1">
																<div className="chat-feilds form-feilds py-3">
																	{/* <div className="settings-feld">
                                                                        <h6 className="card-title mb-0">Side spacing</h6>
                                                                    </div> */}
																	<div className="input-group material-input align-items-center">
																		<TextField label="Side Spacing" style={{ width: 'calc(100% - 40px)' }} id="side_spacing" type="number" className="form-control w-150 flex-none mr-3" name="side_spacing" value={this.state.side_spacing} onChange={this.changePositions} InputLabelProps={{ shrink: true }} variant="outlined" />
																		{/* <input type="number" style={{ width: 'calc(100% - 40px)' }} name="side_spacing" min="0" value={this.state.side_spacing} onChange={this.changePositions} /> */} px
																		<p className="error">{this.state.side_spacing_error}</p>
																	</div>
																</div>
															</div>
															<div className="col-md-4 col-xs-12 z-index1">
																<div className="chat-feilds form-feilds py-3">
																	{/* <div className="settings-feld">
                                                                        <h6 className="card-title mb-0">Bottom spacing</h6>
                                                                    </div> */}
																	<div className="input-group material-input align-items-center">
																		<TextField label="Bottom Spacing" style={{ width: 'calc(100% - 40px)' }} id="bottom_spacing" type="number" className="form-control w-150 flex-none mr-3" name="bottom_spacing" value={this.state.bottom_spacing} onChange={this.changePositions} InputLabelProps={{ shrink: true }} variant="outlined" />
																		{/* <input type="number" style={{ width: 'calc(100% - 40px)' }} name="bottom_spacing" min="0" value={this.state.bottom_spacing} onChange={this.changePositions} /> */} px
																		<p className="error">{this.state.bottom_spacing_error}</p>
																	</div>
																</div>
															</div>
														</div>
													</div>

													{/* Pop Up Widget Advance Settings Part Starts Here */}
													{/* <div className="row">
                                                        <div className="col-md-12">
                                                            <div className="chat-feilds py-5 mx-8 mob-mx-4 borderBottom">
                                                                <div className={`settings-feld form-feilds k-flex align-items-center mb-3`}>

                                                                    <h6 className="card-title mb-0">Pop Up Widget</h6>
                                                                    {this.state.activatePopUpWidget ? (<div className="mx-5 custom-switch">
                                                                        <input type="checkbox" className="custom-control-input" id="switchWidget" name="popUpWidgetCheck" checked={this.state.activatePopUpWidget} onChange={(event) => { this.setState({ activatePopUpWidget: event.target.checked }) }} />
                                                                        <label className="custom-control-label" htmlFor="switchWidget"></label>
                                                                    </div>) : (<div className="mx-5 custom-switch">
                                                                        <input type="checkbox" className="custom-control-input" id="switchWidget" name="popUpWidgetCheck" checked={this.state.activatePopUpWidget} onChange={(event) => { this.setState({ activatePopUpWidget: event.target.checked }, () => this.openPopUpMenu(this.state.popUpMenuOpened)) }} />
                                                                        <label className="custom-control-label" htmlFor="switchWidget"></label>
                                                                    </div>)}
                                                                </div>
                                                                <div className='d-flex flex-wrap mob-col-rev align-items-center'>
                                                                    <div className='imageList'>
                                                                        <div>
                                                                            <ul className="d-flex flex-wrap">
                                                                                <li className={this.state.popUpMenuOpened==='1'?'active':''} onClick={() => this.openPopUpMenu("1", "Advance")}>
                                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="76" height="61" viewBox="0 0 76 61"> <g id="Group_13142" data-name="Group 13142" transform="translate(-318 -765)"> <rect id="Rectangle_1740" data-name="Rectangle 1740" width="76" height="61" rx="6" transform="translate(318 765)" fill="#d8d8d8" /> <g id="Group_13141" data-name="Group 13141"> <rect id="Rectangle_1741" data-name="Rectangle 1741" width="61" height="9" rx="2" transform="translate(326 810)" fill="#fff" /> <g id="Group_13132" data-name="Group 13132"> <rect id="Rectangle_1742" data-name="Rectangle 1742" width="22" height="3" rx="1.5" transform="translate(327 785)" fill="#fff" /> <rect id="Rectangle_1743" data-name="Rectangle 1743" width="13" height="3" rx="1.5" transform="translate(327 791)" fill="#fff" /> </g> <g id="Group_13133" data-name="Group 13133" transform="translate(0 -1)"> <g id="Polygon_2" data-name="Polygon 2" transform="translate(353 784)" fill="#d8d8d8"> <path d="M 14.58030128479004 14.99999618530273 L 3.419690847396851 14.99999618530273 C 2.901960849761963 14.99999618530273 2.643550872802734 14.65371608734131 2.556480884552002 14.50484561920166 C 2.46941089630127 14.35596561431885 2.29430103302002 13.96097564697266 2.548120975494385 13.50973606109619 L 8.12843132019043 3.589195728302002 C 8.387210845947266 3.129125833511353 8.824151039123535 3.079465866088867 9.000000953674316 3.079465866088867 C 9.175850868225098 3.079465866088867 9.612791061401367 3.129125833511353 9.871581077575684 3.589195728302002 L 15.45188140869141 13.50973606109619 C 15.70570087432861 13.96097564697266 15.53059101104736 14.35596561431885 15.44352054595947 14.5048360824585 C 15.3564510345459 14.65371608734131 15.09803104400635 14.99999618530273 14.58030128479004 14.99999618530273 Z" stroke="none" /> <path d="M 9 4.07945728302002 L 9.000000953674316 4.079455375671387 L 3.41969108581543 13.99999618530273 L 14.58030128479004 13.99999618530273 L 9.00001049041748 4.079475402832031 C 9.000007629394531 4.079469680786133 9.000003814697266 4.079463005065918 9 4.07945728302002 M 9.000000953674316 2.079461097717285 C 9.680423736572266 2.079461097717285 10.3608455657959 2.419285774230957 10.74315071105957 3.098936080932617 L 16.32345008850098 13.01947593688965 C 17.07339096069336 14.35268592834473 16.10996055603027 15.99999618530273 14.58030128479004 15.99999618530273 L 3.41969108581543 15.99999618530273 C 1.890041351318359 15.99999618530273 0.9266109466552734 14.35268592834473 1.676540374755859 13.01947593688965 L 7.256851196289062 3.098936080932617 C 7.639156341552734 2.419285774230957 8.319578170776367 2.079461097717285 9.000000953674316 2.079461097717285 Z" stroke="none" fill="#fff" /> </g> <g id="Polygon_1" data-name="Polygon 1" transform="translate(362 779)" fill="#d8d8d8"> <path d="M 20.55363845825195 20 L 3.446359157562256 20 C 2.926609039306641 20 2.668359041213989 19.65167999267578 2.581449031829834 19.50193023681641 C 2.494539022445679 19.35217094421387 2.320249080657959 18.95512962341309 2.578119039535522 18.50386047363281 L 11.13174915313721 3.534990549087524 C 11.3916187286377 3.080220460891724 11.8255090713501 3.03113055229187 11.99999904632568 3.03113055229187 C 12.17448902130127 3.03113055229187 12.60837936401367 3.080220460891724 12.86824893951416 3.534990549087524 L 21.42188835144043 18.50386047363281 C 21.67975997924805 18.95514106750488 21.50545883178711 19.35217094421387 21.41854858398438 19.50193023681641 C 21.33163833618164 19.65167999267578 21.07339859008789 20 20.55363845825195 20 Z" stroke="none" /> <path d="M 11.99999904632568 4.031129837036133 L 3.446359634399414 18.99999046325684 C 3.446357727050781 18.9999942779541 3.446355819702148 18.99999618530273 3.446353912353516 19 C 3.446355819702148 19 3.446357727050781 19 3.446359634399414 19 L 20.55363845825195 19 L 12.00000953674316 4.031129837036133 C 12.0000057220459 4.031129837036133 12.00000190734863 4.031129837036133 11.99999904632568 4.031129837036133 M 11.99999904632568 2.0311279296875 C 12.67629623413086 2.0311279296875 13.35259437561035 2.367034912109375 13.73648929595947 3.038850784301758 L 22.29012870788574 18.00772094726562 C 23.0520191192627 19.34103965759277 22.08928871154785 21 20.55363845825195 21 L 3.446359634399414 21 C 1.91071891784668 21 0.9479789733886719 19.34103965759277 1.709869384765625 18.00772094726562 L 10.26350879669189 3.038850784301758 C 10.64740371704102 2.367034912109375 11.32370185852051 2.0311279296875 11.99999904632568 2.0311279296875 Z" stroke="none" fill="#fff" /> </g> </g> </g> </g> </svg>
                                                                                    <p>Image Right</p>
                                                                                </li>
                                                                                <li className={this.state.popUpMenuOpened==='2'?'active':''} onClick={() => this.openPopUpMenu("2", "Advance")}>
                                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="76" height="61" viewBox="0 0 76 61"> <g id="Group_13143" data-name="Group 13143" transform="translate(-452 -765)"> <rect id="Rectangle_1746" data-name="Rectangle 1746" width="76" height="61" rx="6" transform="translate(452 765)" fill="#d8d8d8" /> <g id="Group_13140" data-name="Group 13140"> <rect id="Rectangle_1745" data-name="Rectangle 1745" width="61" height="9" rx="2" transform="translate(460 810)" fill="#fff" /> <g id="Group_13135" data-name="Group 13135" transform="translate(498 785)"> <rect id="Rectangle_1742" data-name="Rectangle 1742" width="22" height="3" rx="1.5" fill="#fff" /> <rect id="Rectangle_1743" data-name="Rectangle 1743" width="13" height="3" rx="1.5" transform="translate(9 6)" fill="#fff" /> </g> <g id="Group_13134" data-name="Group 13134" transform="translate(461 778)"> <g id="Polygon_2" data-name="Polygon 2" transform="translate(15 5)" fill="#d8d8d8"> <path d="M 14.58030128479004 14.99999618530273 L 3.419690847396851 14.99999618530273 C 2.901960849761963 14.99999618530273 2.643550872802734 14.65371608734131 2.556480884552002 14.50484561920166 C 2.46941089630127 14.35596561431885 2.29430103302002 13.96097564697266 2.548120975494385 13.50973606109619 L 8.12843132019043 3.589195728302002 C 8.387210845947266 3.129125833511353 8.824151039123535 3.079465866088867 9.000000953674316 3.079465866088867 C 9.175850868225098 3.079465866088867 9.612791061401367 3.129125833511353 9.871581077575684 3.589195728302002 L 15.45188140869141 13.50973606109619 C 15.70570087432861 13.96097564697266 15.53059101104736 14.35596561431885 15.44352054595947 14.5048360824585 C 15.3564510345459 14.65371608734131 15.09803104400635 14.99999618530273 14.58030128479004 14.99999618530273 Z" stroke="none" /> <path d="M 9 4.07945728302002 L 9.000000953674316 4.079455375671387 L 3.41969108581543 13.99999618530273 L 14.58030128479004 13.99999618530273 L 9.00001049041748 4.079475402832031 C 9.000007629394531 4.079469680786133 9.000003814697266 4.079463005065918 9 4.07945728302002 M 9.000000953674316 2.079461097717285 C 9.680423736572266 2.079461097717285 10.3608455657959 2.419285774230957 10.74315071105957 3.098936080932617 L 16.32345008850098 13.01947593688965 C 17.07339096069336 14.35268592834473 16.10996055603027 15.99999618530273 14.58030128479004 15.99999618530273 L 3.41969108581543 15.99999618530273 C 1.890041351318359 15.99999618530273 0.9266109466552734 14.35268592834473 1.676540374755859 13.01947593688965 L 7.256851196289062 3.098936080932617 C 7.639156341552734 2.419285774230957 8.319578170776367 2.079461097717285 9.000000953674316 2.079461097717285 Z" stroke="none" fill="#fff" /> </g> <g id="Polygon_1" data-name="Polygon 1" fill="#d8d8d8"> <path d="M 20.55363845825195 20 L 3.446359157562256 20 C 2.926609039306641 20 2.668359041213989 19.65167999267578 2.581449031829834 19.50193023681641 C 2.494539022445679 19.35217094421387 2.320249080657959 18.95512962341309 2.578119039535522 18.50386047363281 L 11.13174915313721 3.534990549087524 C 11.3916187286377 3.080220460891724 11.8255090713501 3.03113055229187 11.99999904632568 3.03113055229187 C 12.17448902130127 3.03113055229187 12.60837936401367 3.080220460891724 12.86824893951416 3.534990549087524 L 21.42188835144043 18.50386047363281 C 21.67975997924805 18.95514106750488 21.50545883178711 19.35217094421387 21.41854858398438 19.50193023681641 C 21.33163833618164 19.65167999267578 21.07339859008789 20 20.55363845825195 20 Z" stroke="none" /> <path d="M 11.99999904632568 4.031129837036133 L 3.446359634399414 18.99999046325684 C 3.446357727050781 18.9999942779541 3.446355819702148 18.99999618530273 3.446353912353516 19 C 3.446355819702148 19 3.446357727050781 19 3.446359634399414 19 L 20.55363845825195 19 L 12.00000953674316 4.031129837036133 C 12.0000057220459 4.031129837036133 12.00000190734863 4.031129837036133 11.99999904632568 4.031129837036133 M 11.99999904632568 2.0311279296875 C 12.67629623413086 2.0311279296875 13.35259437561035 2.367034912109375 13.73648929595947 3.038850784301758 L 22.29012870788574 18.00772094726562 C 23.0520191192627 19.34103965759277 22.08928871154785 21 20.55363845825195 21 L 3.446359634399414 21 C 1.91071891784668 21 0.9479789733886719 19.34103965759277 1.709869384765625 18.00772094726562 L 10.26350879669189 3.038850784301758 C 10.64740371704102 2.367034912109375 11.32370185852051 2.0311279296875 11.99999904632568 2.0311279296875 Z" stroke="none" fill="#fff" /> </g> </g> </g> </g> </svg>
                                                                                    <p>Image Left</p>
                                                                                </li>
                                                                                <li className={this.state.popUpMenuOpened==='3'?'active':''} onClick={() => this.openPopUpMenu("3", "Advance")}>
                                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="76" height="61" viewBox="0 0 76 61"> <g id="Group_13139" data-name="Group 13139" transform="translate(-569 -765)"> <rect id="Rectangle_1748" data-name="Rectangle 1748" width="76" height="61" rx="6" transform="translate(569 765)" fill="#d8d8d8" /> <rect id="Rectangle_1747" data-name="Rectangle 1747" width="61" height="9" rx="2" transform="translate(577 810)" fill="#fff" /> <g id="Group_13136" data-name="Group 13136" transform="translate(597 785)"> <rect id="Rectangle_1742" data-name="Rectangle 1742" width="50" height="3" rx="1.5" transform="translate(-14 -6)" fill="#fff" /> <rect id="Rectangle_1749" data-name="Rectangle 1749" width="36" height="3" rx="1.5" transform="translate(-7 2)" fill="#fff" /> <rect id="Rectangle_1750" data-name="Rectangle 1750" width="36" height="3" rx="1.5" transform="translate(-7 10)" fill="#fff" /> </g> </g> </svg>
                                                                                    <p>Text Only</p>
                                                                                </li>
                                                                                <li className={this.state.popUpMenuOpened==='4'?'active':''} onClick={() => this.openPopUpMenu("4", "Advance")}>
                                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="76" height="61" viewBox="0 0 76 61"> <g id="Group_13138" data-name="Group 13138" transform="translate(-682 -765)"> <rect id="Rectangle_1751" data-name="Rectangle 1751" width="76" height="61" rx="6" transform="translate(682 765)" fill="#d8d8d8" /> <rect id="Rectangle_1752" data-name="Rectangle 1752" width="61" height="9" rx="2" transform="translate(690 810)" fill="#fff" /> <g id="Group_13137" data-name="Group 13137" transform="translate(351 -1)"> <g id="Polygon_2" data-name="Polygon 2" transform="translate(353 784)" fill="#d8d8d8"> <path d="M 14.58030128479004 14.99999618530273 L 3.419690847396851 14.99999618530273 C 2.901960849761963 14.99999618530273 2.643550872802734 14.65371608734131 2.556480884552002 14.50484561920166 C 2.46941089630127 14.35596561431885 2.29430103302002 13.96097564697266 2.548120975494385 13.50973606109619 L 8.12843132019043 3.589195728302002 C 8.387210845947266 3.129125833511353 8.824151039123535 3.079465866088867 9.000000953674316 3.079465866088867 C 9.175850868225098 3.079465866088867 9.612791061401367 3.129125833511353 9.871581077575684 3.589195728302002 L 15.45188140869141 13.50973606109619 C 15.70570087432861 13.96097564697266 15.53059101104736 14.35596561431885 15.44352054595947 14.5048360824585 C 15.3564510345459 14.65371608734131 15.09803104400635 14.99999618530273 14.58030128479004 14.99999618530273 Z" stroke="none" /> <path d="M 9 4.07945728302002 L 9.000000953674316 4.079455375671387 L 3.41969108581543 13.99999618530273 L 14.58030128479004 13.99999618530273 L 9.00001049041748 4.079475402832031 C 9.000007629394531 4.079469680786133 9.000003814697266 4.079463005065918 9 4.07945728302002 M 9.000000953674316 2.079461097717285 C 9.680423736572266 2.079461097717285 10.3608455657959 2.419285774230957 10.74315071105957 3.098936080932617 L 16.32345008850098 13.01947593688965 C 17.07339096069336 14.35268592834473 16.10996055603027 15.99999618530273 14.58030128479004 15.99999618530273 L 3.41969108581543 15.99999618530273 C 1.890041351318359 15.99999618530273 0.9266109466552734 14.35268592834473 1.676540374755859 13.01947593688965 L 7.256851196289062 3.098936080932617 C 7.639156341552734 2.419285774230957 8.319578170776367 2.079461097717285 9.000000953674316 2.079461097717285 Z" stroke="none" fill="#fff" /> </g> <g id="Polygon_1" data-name="Polygon 1" transform="translate(362 779)" fill="#d8d8d8"> <path d="M 20.55363845825195 20 L 3.446359157562256 20 C 2.926609039306641 20 2.668359041213989 19.65167999267578 2.581449031829834 19.50193023681641 C 2.494539022445679 19.35217094421387 2.320249080657959 18.95512962341309 2.578119039535522 18.50386047363281 L 11.13174915313721 3.534990549087524 C 11.3916187286377 3.080220460891724 11.8255090713501 3.03113055229187 11.99999904632568 3.03113055229187 C 12.17448902130127 3.03113055229187 12.60837936401367 3.080220460891724 12.86824893951416 3.534990549087524 L 21.42188835144043 18.50386047363281 C 21.67975997924805 18.95514106750488 21.50545883178711 19.35217094421387 21.41854858398438 19.50193023681641 C 21.33163833618164 19.65167999267578 21.07339859008789 20 20.55363845825195 20 Z" stroke="none" /> <path d="M 11.99999904632568 4.031129837036133 L 3.446359634399414 18.99999046325684 C 3.446357727050781 18.9999942779541 3.446355819702148 18.99999618530273 3.446353912353516 19 C 3.446355819702148 19 3.446357727050781 19 3.446359634399414 19 L 20.55363845825195 19 L 12.00000953674316 4.031129837036133 C 12.0000057220459 4.031129837036133 12.00000190734863 4.031129837036133 11.99999904632568 4.031129837036133 M 11.99999904632568 2.0311279296875 C 12.67629623413086 2.0311279296875 13.35259437561035 2.367034912109375 13.73648929595947 3.038850784301758 L 22.29012870788574 18.00772094726562 C 23.0520191192627 19.34103965759277 22.08928871154785 21 20.55363845825195 21 L 3.446359634399414 21 C 1.91071891784668 21 0.9479789733886719 19.34103965759277 1.709869384765625 18.00772094726562 L 10.26350879669189 3.038850784301758 C 10.64740371704102 2.367034912109375 11.32370185852051 2.0311279296875 11.99999904632568 2.0311279296875 Z" stroke="none" fill="#fff" /> </g> </g> </g> </svg>
                                                                                    <p>Image Only</p>
                                                                                </li>
                                                                            </ul>
                                                                        </div>

                                                                        {this.state.activatePopUpWidget === true ?
                                                                            (<>
                                                                                <div id="imageRightAdvance" className="tabcontent" style={{ display: 'none' }}>
                                                                                    <div className='color-picker mt-4'>
                                                                                        <label htmlFor="backgroundColorPopUp1">Background Color</label>
                                                                                        <div className='d-flex flex-wrap'>
                                                                                            <span className='picker-input'>
                                                                                                <input type="color" id="backgroundColorPopUp1" name="backgroundColorPopUp1" defaultValue={this.state.popUpBackgroundColor} onChange={(event) => this.setState({ popUpBackgroundColor: event.target.value })} />
                                                                                                {this.state.popUpBackgroundColor}
                                                                                            </span>
                                                                                            <span className='picker-text'>
                                                                                                <input type="checkbox" id="sameBackgroundColor1" name="sameBackgroundColor1" defaultValue={this.state.userbgColor} onClick={(event) => this.handleOnClick(event)} />
                                                                                                <label htmlFor="sameBackgroundColor1">Same as theme color</label>
                                                                                            </span>
                                                                                        </div>

                                                                                    </div>

                                                                                    <div className="form-feilds">
                                                                                        <div className="input-group material-input mb-5 mt-4">
                                                                                            <label htmlFor="popUpMessage1">Message</label>
                                                                                            <TextField className="form-control w-100" rows={4} id="popUpMessage1" variant="outlined" name="popUpMessage1" placeholder={this.state.defaultMessagePlaceholder} defaultValue={this.state.popUpMessage} multiline onChange={(event) => { this.setState({ popUpMessage: event.target.value }) }} />
                                                                                            <p className="error">{this.state.popUpMessageError}</p>
                                                                                        </div>
                                                                                        <div className="upload-view">
                                                                                            <label htmlFor="popUpImage1">Image:</label>
                                                                                            <div className='upload-box mb-3'>
                                                                                                {backgroundImageUploading}
                                                                                                <span className='upImg-view'>
                                                                                                    {this.state.showPopUpImagePreview ? (<img id="popUpImagePreview1" src={this.state.popUpImageSrc} alt="Your image" />) : (null)}
                                                                                                    <span className='up-icon'>+</span>
                                                                                                    Drag & Drop or <span>Click</span> to upload a image
                                                                                                </span>

                                                                                                <input type="file" id="popUpImage1" name="popUpImage1" accept="image/png, image/jpeg, , image/jpg, image/bmp" onChange={(event) => { this.showPopUpImage(event, "popUpImagePreview1", "popUpImage1", this.state.placeholdImageSrc, 200, 200) }} />
                                                                                                <a className='delete-btn' onClick={() => { try { document.getElementById("popUpImage1").value = ""; document.getElementById("popUpImagePreview1").src = this.state.placeholdImageSrc; this.setState({ showPopUpImagePreview: false, popUpImageSrc: this.state.placeholdImageSrc }) } catch (e) { } }}>
                                                                                                    <img id="popUpImageDelete1" src={require('../../../assets/img/icon/delete-new.svg')} alt="Delete" />
                                                                                                </a>
                                                                                            </div>
                                                                                            <small>Maximum size is 1 MB. Recommended dimensions is 100x100px. </small>
                                                                                            <small>To support retina displays, recommended dimensions is 200x200px.</small>
                                                                                        </div>

                                                                                    </div>

                                                                                </div>

                                                                                <div id="imageLeftAdvance" className="tabcontent" style={{ display: 'none' }}>
                                                                                    <div className='color-picker mt-4'>
                                                                                        <label htmlFor="backgroundColorPopUp2">Background Color</label>
                                                                                        <div className='d-flex flex-wrap'>
                                                                                            <span className='picker-input'>
                                                                                                <input type="color" id="backgroundColorPopUp2" name="backgroundColorPopUp2" defaultValue={this.state.popUpBackgroundColor} onChange={(event) => this.setState({ popUpBackgroundColor: event.target.value })} />
                                                                                                {this.state.popUpBackgroundColor}
                                                                                            </span>
                                                                                            <span className='picker-text'>
                                                                                                <input type="checkbox" id="sameBackgroundColor2" name="sameBackgroundColor2" defaultValue={this.state.userbgColor} onClick={(event) => this.handleOnClick(event)} />
                                                                                                <label htmlFor="sameBackgroundColor2">Same as theme color</label>
                                                                                            </span>
                                                                                        </div>
                                                                                    </div>


                                                                                    <div className="form-feilds">
                                                                                        <div className="input-group material-input mb-5 mt-4">
                                                                                            <label htmlFor="popUpMessage2">Message</label>
                                                                                            <TextField className="form-control w-100" rows={4} id="popUpMessage2" variant="outlined" name="popUpMessage2" placeholder={this.state.defaultMessagePlaceholder} defaultValue={this.state.popUpMessage} multiline onChange={(event) => { this.setState({ popUpMessage: event.target.value }) }} />
                                                                                            <p className="error">{this.state.popUpMessageError}</p>
                                                                                        </div>

                                                                                        <div className="upload-view aa">
                                                                                            <label htmlFor="popUpImage2">Image:</label>
                                                                                            <div className='upload-box mb-3'>
                                                                                                {backgroundImageUploading}
                                                                                                <span className='upImg-view'>
                                                                                                    {this.state.showPopUpImagePreview ? (<img id="popUpImagePreview2" src={this.state.popUpImageSrc} alt="Your image" />) : (null)}
                                                                                                    <span className='up-icon'>+</span>
                                                                                                    Drag & Drop or <span>Click</span> to upload a image
                                                                                                </span>

                                                                                                <input type="file" id="popUpImage2" name="popUpImage2" accept="image/png, image/jpeg, , image/jpg, image/bmp" onChange={(event) => { this.showPopUpImage(event, "popUpImagePreview2", "popUpImage2", this.state.placeholdImageSrc, 200, 200) }} />
                                                                                                <a className='delete-btn' onClick={() => { try { document.getElementById("popUpImage2").value = ""; document.getElementById("popUpImagePreview2").src = this.state.placeholdImageSrc; this.setState({ showPopUpImagePreview: false, popUpImageSrc: this.state.placeholdImageSrc }) } catch (e) { } }}>
                                                                                                    <img id="popUpImageDelete2" src={require('../../../assets/img/icon/delete-new.svg')} alt="Delete" />
                                                                                                </a>
                                                                                            </div>
                                                                                            <small>Maximum size is 1 MB. Recommended dimensions is 100x100px. </small>
                                                                                            <small>To support retina displays, recommended dimensions is 200x200px.</small>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>

                                                                                <div id="textOnlyAdvance" className="tabcontent" style={{ display: 'none' }}>
                                                                                    <div className='color-picker mt-4'>
                                                                                        <label htmlFor="backgroundColorPopUp3">Background Color</label>
                                                                                        <div className='d-flex flex-wrap'>
                                                                                            <span className='picker-input'>
                                                                                                <input type="color" id="backgroundColorPopUp3" name="backgroundColorPopUp3" defaultValue={this.state.popUpBackgroundColor} onChange={(event) => this.setState({ popUpBackgroundColor: event.target.value })} />
                                                                                                {this.state.popUpBackgroundColor}
                                                                                            </span>
                                                                                            <span className='picker-text'>
                                                                                                <input type="checkbox" id="sameBackgroundColor3" name="sameBackgroundColor3" defaultValue={this.state.userbgColor} onClick={(event) => this.handleOnClick(event)} />
                                                                                                <label htmlFor="sameBackgroundColor3">Same as theme color</label>
                                                                                            </span>
                                                                                        </div>
                                                                                    </div>

                                                                                    <div className="form-feilds">
                                                                                        <div className="input-group material-input mb-5 mt-4">
                                                                                            <label htmlFor="popUpMessage3">Message</label>
                                                                                            <TextField className="form-control w-100" rows={4} id="popUpMessage3" variant="outlined" name="popUpMessage3" placeholder={this.state.defaultMessagePlaceholder} defaultValue={this.state.popUpMessage} multiline onChange={(event) => { this.setState({ popUpMessage: event.target.value }) }} />
                                                                                            <p className="error">{this.state.popUpMessageError}</p>
                                                                                        </div>

                                                                                    </div>
                                                                                </div>

                                                                                <div id="imageOnlyAdvance" className="tabcontent" style={{ display: 'none' }}>
                                                                                    <div className='color-picker mt-4'>
                                                                                        <label htmlFor="backgroundColorPopUp4">Background Color</label>
                                                                                        <div className='d-flex flex-wrap'>
                                                                                            <span className='picker-input'>
                                                                                                <input type="color" id="backgroundColorPopUp4" name="backgroundColorPopUp4" defaultValue={this.state.popUpBackgroundColor} onChange={(event) => this.setState({ popUpBackgroundColor: event.target.value })} />
                                                                                                {this.state.popUpBackgroundColor}
                                                                                            </span>
                                                                                            <span className='picker-text'>
                                                                                                <input type="checkbox" id="sameBackgroundColor4" name="sameBackgroundColor4" defaultValue={this.state.userbgColor} onClick={(event) => this.handleOnClick(event)} />
                                                                                                <label htmlFor="sameBackgroundColor4">Same as theme color</label>
                                                                                            </span>
                                                                                        </div>
                                                                                    </div>

                                                                                    <div className="form-feilds">

                                                                                        <div className="upload-view">
                                                                                            <label htmlFor="popUpImage4">Image:</label>
                                                                                            <div className='upload-box mb-3'>
                                                                                                {backgroundImageUploading}
                                                                                                <span className='upImg-view'>
                                                                                                    {this.state.showPopUpImagePreview ? (<img id="popUpImagePreview4" src={this.state.popUpImageSrc} alt="Your image" />) : (null)}
                                                                                                    <span className='up-icon'>+</span>
                                                                                                    Drag & Drop or <span>Click</span> to upload a image
                                                                                                </span>

                                                                                                <input type="file" id="popUpImage4" name="popUpImage4" accept="image/png, image/jpeg, , image/jpg, image/bmp" onChange={(event) => { this.showPopUpImage(event, "popUpImagePreview4", "popUpImage4", this.state.placeholdImageSrc, 480, 328) }} />
                                                                                                <a className='delete-btn' onClick={() => { try { document.getElementById("popUpImage4").value = ""; document.getElementById("popUpImagePreview4").src = this.state.placeholdImageSrc; this.setState({ showPopUpImagePreview: false, popUpImageSrc: this.state.placeholdImageSrc }) } catch (e) { } }}>
                                                                                                    <img id="popUpImageDelete4" src={require('../../../assets/img/icon/delete-new.svg')} alt="Delete" />
                                                                                                </a>
                                                                                            </div>
                                                                                            <small>Maximum size is 1 MB. Recommended dimensions is 240x164px. </small>
                                                                                            <small>To support retina displays, recommended dimensions is 480x328px.</small>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </>) : (null)}
                                                                    </div>
                                                                    {this.state.activatePopUpWidget === true ? (<>
                                                                        <div className='text-img-view'>
                                                                            {this.state.popUpMenuOpened === '1' ?
                                                                                (<div className='default-view' id="popUpDiv1" contentEditable="false" style={{ backgroundColor: this.state.popUpBackgroundColor }} suppressContentEditableWarning='true'>
                                                                                    <span className='default-head'>{this.state.headerText}</span>
                                                                                    <div className='d-flex flex-wrap view px-5 py-4 align-items-center'>
                                                                                        <p>{this.state.popUpMessage ? this.state.popUpMessage : this.state.defaultMessagePlaceholder}</p>
                                                                                        <img id="popUpImageMessageId1" src={this.state.popUpImageSrc} alt="Your image" />
                                                                                    </div>
                                                                                    <div className='inputView'>
                                                                                        {this.state.popUpWidgetPlaceholder}
                                                                                        <img src={require('./../../../assets/img/icon/send-icon.svg')} alt='send icon' />
                                                                                    </div>
                                                                                </div>) :
                                                                                (this.state.popUpMenuOpened === '2' ?
                                                                                    (<div className='default-view' id="popUpDiv2" contentEditable="false" style={{ backgroundColor: this.state.popUpBackgroundColor }} suppressContentEditableWarning='true'>
                                                                                        <span className='default-head'>{this.state.headerText}</span>
                                                                                        <div className='d-flex flex-wrap view px-5 py-4 align-items-center'>
                                                                                            <img id="popUpImageMessageId2" src={this.state.popUpImageSrc} alt="Your image" />
                                                                                            <p> {this.state.popUpMessage ? this.state.popUpMessage : this.state.defaultMessagePlaceholder}</p>
                                                                                        </div>
                                                                                        <div className='inputView'>
                                                                                            {this.state.popUpWidgetPlaceholder}
                                                                                            <img src={require('./../../../assets/img/icon/send-icon.svg')} alt='send icon' />
                                                                                        </div>
                                                                                    </div>) :
                                                                                    (this.state.popUpMenuOpened === '3' ?
                                                                                        (<div className='default-view' id="popUpDiv3" contentEditable="false" style={{ backgroundColor: this.state.popUpBackgroundColor }} suppressContentEditableWarning='true'>
                                                                                            <span className='default-head'>{this.state.headerText}</span>
                                                                                            <div className='view px-5 py-4'>
                                                                                                <p> {this.state.popUpMessage ? this.state.popUpMessage : this.state.defaultMessagePlaceholder}</p>
                                                                                            </div>
                                                                                            <div className='inputView'>
                                                                                                {this.state.popUpWidgetPlaceholder}
                                                                                                <img src={require('./../../../assets/img/icon/send-icon.svg')} alt='send icon' />
                                                                                            </div>

                                                                                        </div>) :
                                                                                        (this.state.popUpMenuOpened === '4' ?
                                                                                            (<div className='default-view' id="popUpDiv4" contentEditable="false" style={{ backgroundColor: this.state.popUpBackgroundColor }} suppressContentEditableWarning='true'>
                                                                                                <span className='default-head'>{this.state.headerText}</span>
                                                                                                <div className='view px-5 py-4'>
                                                                                                    <img id="popUpImageMessageId4" src={this.state.popUpImageSrc} alt="Your image" style={{ width: 'auto', height: '50px' }} />
                                                                                                </div>
                                                                                                <div className='inputView'>
                                                                                                    {this.state.popUpWidgetPlaceholder}
                                                                                                    <img src={require('./../../../assets/img/icon/send-icon.svg')} alt='send icon' />
                                                                                                </div>
                                                                                            </div>) :
                                                                                            (null)
                                                                                        )
                                                                                    )
                                                                                )
                                                                            }
                                                                        </div>
                                                                    </>) : (null)}

                                                                </div>                                                                
                                                            </div>
                                                        </div>
                                                    </div> */}
													{/* Pop Up Widget Advance Settings Part Ends Here */}

													<div className="py-5 mx-8">
														<div className="row">
															<div className="col-md-12 col-xs-12">
																<div className="chat-feilds py-3">
																	<div className="settings-feld">
																		<h5 className="card-title mb-0">White lable widget</h5>
																	</div>
																	<div className="wrapperInfo">
																		<div style={{ fontSize: '13px', color: '#000' }}> Remove
																			<span className="powerdBySnapyIcon">
																				<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 9.15 12.64">
																					<g data-name="Layer 2">
																						<g data-name="Layer 1">
																							<path fill="#fcf4a0" d="M6.58.75L.75 7.06h3.54l-1.95 4.83L8.4 5.24H4.57L6.58.75z" />
																							<path d="M6.58.75l-2 4.49H8.4l-6.06 6.65 2-4.83H.75L6.58.75m0-.75a.67.67 0 0 0-.37.11.65.65 0 0 0-.21.13L.2 6.55a.75.75 0 0 0 .55 1.26h2.43l-1.54 3.8a.76.76 0 0 0 .3.92.8.8 0 0 0 .4.11.74.74 0 0 0 .55-.24L9 5.75a.75.75 0 0 0-.6-1.26H5.73L7.24 1.1a.68.68 0 0 0 .09-.35.75.75 0 0 0-.74-.75zm0 1.5z" fill="#f4a51f" />
																						</g>
																					</g>
																				</svg>
																			</span>
																			Powered by <img alt="" src="https://chatbot.appypie.com/widget/deffc8a9acefb38beaa89521f4725e2c.svg" style={{ width: '100px', position: 'relative', top: '-2px' }} />
																			&nbsp;label from your chat widget
																			<div className="custom-control custom-control-right custom-switch ml-auto" style={{ display: 'inline' }}>
																				<input type="checkbox" className="custom-control-input" id="switch1" checked={this.state.white_label_widget === true ? true : false} name="white_label_widget" onChange={() => { this.setState({ white_label_widget: this.state.white_label_widget === true ? false : true, value_saved: false }) }} />
																				<label className="custom-control-label" htmlFor="switch1"></label>
																			</div>
																		</div>
																	</div>
																</div>
															</div>
														</div>
													</div>
												</div>) : (null)}
												<div className="row">
													<div className="col-md-12">
														<div className="btn-chat-feilds chat-feilds  py-6 px-8 setting-footer-fixed-RightPreview">
															<div className="wrapperInfo text-left">
																<button className="btnBlueSettings" onClick={this.saveForm}>Save changes</button>&nbsp;&nbsp;
																<button className="btnBorderSettings" onClick={this.cancelForm}>Cancel</button>
															</div>
														</div>
													</div>
												</div>
											</div> : null}
										</div>
									</div>

									<span className="widgetDeskDesignRight" onClick={this.rightWidgetMobileHide} id="widgeHSIcon">
										<svg className="tide-icon " width="8" height="8" viewBox="0 0 14 24"><path d="M12.967 24c-0.241 0-0.482-0.086-0.674-0.263l-11.962-10.994c-0.206-0.189-0.324-0.457-0.324-0.737s0.118-0.547 0.324-0.737l11.962-10.994c0.407-0.373 1.038-0.345 1.409 0.061s0.344 1.039-0.061 1.412l-11.161 10.257 11.161 10.258c0.406 0.372 0.433 1.005 0.061 1.412-0.197 0.215-0.466 0.323-0.736 0.323z"></path></svg>
									</span>

									<div className="widget-seetings-right" id="deskWidgetRightP">
										<SettingView values={this.state} />
									</div>

								</div>
							</div>
						</div>
					</div>
				</div>
			</>
		);
	}
}

export default withRouter(Basicsettings);